const fr = {
lang: { fr: 'Français', en: 'English' },
  nav: {
    home: 'Accueil',
    publishRequest: 'Publier une demande',
    becomeProvider: 'Devenir un prestataire',
    afterSales: 'Service après-vente',
    demos: 'Demos',
    pages: 'Pages',
    login: 'Connexion',
    signup: 'Inscription',
    logout: 'Déconnexion',
    myAccount: 'Mon compte',
    hello: 'Bonjour, {{name}}',
    myPayments: 'Mes paiements',
  },
  footer: {
    pages: 'Pages',
    home: 'Accueil',
    becomeProvider: 'Devenir un prestataire',
    publishRequest: 'Publier une demande',
    afterSales: 'Service après-vente',
    login: 'Connexion',
    signup: 'Inscription',
    rights: 'Tous droits réservés.',
    terms: "Conditions d'utilisation",
    privacy: 'Politique de confidentialité',
    ctaTitle: 'Trouvez un professionnel près de chez vous',
    ctaBody: 'Publiez votre demande en quelques minutes et connectez-vous avec des prestataires locaux de confiance.',
    ctaButton: 'Publier une demande',
    contact: 'Contact',
    copyright: 'Tous droits réservés.',
  },
  home: {
    bannerTitle: 'Trouvez des professionnels locaux de confiance pour tous vos services quotidiens.',
    bannerSub: 'Réservez rapidement, payez en toute sécurité et faites exécuter le travail avec confiance.',
    servicesTitle: 'Tous les services disponibles',
    servicesSub: 'Débloquez le potentiel de notre centre de services, accédez à des services et solutions précieux pour la croissance de votre entreprise.',
    searchPlaceholder: 'Rechercher des services...',
    groupLabel: 'Groupe de Services',
    sortLabel: 'Trier par',
    sortDefault: 'Par défaut',
    sortNameAsc: 'Nom (A-Z)',
    sortNameDesc: 'Nom (Z-A)',
    sortNewest: 'Plus récent d\'abord',
    results: 'Résultats : {{count}} service',
    results_plural: 'Résultats : {{count}} services',
    clearFilters: 'Effacer les filtres',
    loadingServices: 'Chargement des services...',
    noServices: 'Aucun service trouvé. Essayez une autre recherche ou catégorie.',
    viewAllServices: 'Voir Tous les Services',
    mapTitle: 'Position utilisateur et prestataire',
    mapUser: 'Utilisateur',
    mapProvider: 'Prestataire',
    mapYourPosition: 'Votre position',
    groups: {
      all: 'Tous les Services',
      homeWorks: 'Maison & Travaux',
      outdoor: 'Extérieur & Jardin',
      transport: 'Transport',
      security: 'Sécurité',
    },
    howTitle: 'Comment utiliser la plateforme ?',
    step1Title: '1- Publier une demande',
    step1Text: 'Choisissez une catégorie et décrivez votre projet.',
    step2Title: '2- Recevez un devis sous 24h',
    step2Text: 'Examinez les offres des artisans fiables.',
    step3Title: '3- Choisissez votre prestataire',
    step3Text: 'Particulier ou professionnel selon votre budget.',
    step4Title: '4- Trouvez le bon prestataire en quelques clics',
    step4Text: 'Réservez, profitez et partagez votre expérience.',
    trustTitle: 'Pourquoi faire confiance à Allo Alla ?',
    trustP1: 'Allo Alla est une plateforme de services qui met en relation des particuliers ayant besoin d\'aide pour leurs travaux avec des prestataires et des experts qualifiés.',
    trustP2: 'Trouvez un prestataire pour tous vos besoins en rénovation domiciliaire.',
    trustP3: 'En moins de 48 heures, vous pouvez recevoir des offres pour poser une étagère, installer une cuisine, peindre un mur, carreler une salle de bain ou entretenir votre jardin.',
    trustP4: 'Notre réseau de professionnels qualifiés est rigoureusement sélectionné et vérifié par notre équipe. Vous pouvez consulter les avis clients ainsi que les distinctions obtenues par les prestataires.',
    trustP5: 'Nos services incluent des garanties de qualité pour vous accompagner en cas d\'imprévu, avec des conditions claires et une assistance dédiée tout au long de votre projet.',
    providerTitle: 'Voulez-vous devenir prestataire ?',
    providerP1: 'Vous êtes un professionnel du commerce ? Inscrivez-vous en ligne dès maintenant pour accéder en exclusivité aux offres d\'emploi qualifiées publiées par nos partenaires.',
    providerP2: 'Ou peut-être êtes-vous un particulier qui préfère réaliser des petits travaux pendant son temps libre ? Devenez artisan Allo Alla et recevez des demandes directement sur votre téléphone.',
    providerP3: 'Dans tous les cas, notre service est 100 % gratuit pour les prestataires.',
    providerLi1: 'Trouvez des emplois près de chez vous',
    providerLi2: 'Soumettez votre devis',
    providerLi3: 'Soyez payé',
    providerP4: 'L\'équipe Allo Alla vérifie chaque artisan inscrit via son identité, ses informations d\'entreprise (pour les professionnels), ses certificats de qualification et ses documents d\'assurance.',
    becomeArtisan: 'Devenir artisan',
  },
  payment: {
    title: 'Paiement',
    canceled: 'Paiement annulé. Vous pouvez réessayer ci-dessous.',
    amountToPay: 'Montant à payer',
    card: 'Carte bancaire',
    onSite: 'Sur place',
    cardTitle: 'Paiement par carte',
    onSiteTitle: 'Paiement sur place',
    cardSub: 'Renseignez vos informations pour finaliser le règlement.',
    onSiteSub: 'Confirmez que vous réglerez ce montant en espèces auprès du prestataire.',
    commentLabel: 'Commentaire (optionnel)',
    commentPlaceholder: 'Ex: Je paierai à la fin de l\'intervention',
    confirm: 'Confirmer {{amount}}',
    saving: 'Enregistrement…',
    back: 'Retour',
    invalidAmount: 'Montant invalide',
    loadingStripe: 'Chargement de la configuration Stripe…',
    backendError: 'Impossible de joindre le backend (port 5001). Redémarrez le serveur.',
    stripeKeyMissing: 'Clé publique Stripe manquante dans backend/.env (STRIPE_PUBLISHABLE_KEY=pk_test_...).',
    payStripe: 'Payer {{amount}} (page Stripe)',
    redirecting: 'Redirection…',
    defaultDescription: 'Prestation de service',
    summaryTitle: 'Récapitulatif',
    service: 'Service',
    subtotal: 'Sous-total',
    vatIncluded: 'TVA (incluse)',
    total: 'Total',
    stripeRedirectError: 'Redirection Stripe impossible.',
    stripeError: 'Erreur Stripe.',
    onSiteSaveError: 'Enregistrement du paiement sur place impossible.',
    saveError: 'Erreur lors de l’enregistrement.',
    paymentDescription: 'Paiement Nioland',
    onSiteDescription: 'Paiement sur place',
    serviceReminderBanner: 'Vous réglez : {{desc}}',
    receiptNote: 'Un reçu sera envoyé à {{email}} après le paiement.',
    trustEncrypted: 'Chiffré',
    trustStripe: 'Sécurisé par Stripe',
    trustReceipt: 'Reçu par e-mail',
    onSiteWarning: 'Attention : les paiements sur place doivent être confirmés par votre prestataire avant le début de la prestation.',
    allFeesNote: 'toutes taxes comprises',
    cardForm: {
      cardholderName: 'Nom sur la carte',
      cardholderPlaceholder: 'Jean Dupont',
      billingEmail: 'E-mail de facturation',
      billingEmailPlaceholder: 'vous@exemple.fr',
      cardNumber: 'Numéro de carte',
      expiry: "Date d'expiration",
      cvc: 'Cryptogramme (CVC)',
      pay: 'Payer {{amount}}',
      paying: 'Paiement en cours…',
      secureNote: 'Paiement chiffré via Stripe · Nous ne stockons pas vos données bancaires',
      stripeNotLoaded: 'Stripe n’est pas encore chargé. Réessayez dans un instant.',
      amountInvalid: 'Indiquez un montant valide dans le récapitulatif.',
      nameRequired: 'Indiquez le nom sur la carte',
      emailRequired: 'Indiquez l’e-mail de facturation',
      formUnavailable: 'Formulaire carte indisponible',
      prepareFailed: 'Impossible de préparer le paiement par carte.',
      pending: 'Paiement en attente de confirmation.',
      error: 'Erreur lors du paiement par carte.',
      declined: 'Paiement refusé.',
    },
    stripeErrors: {
      cardNumberIncomplete: 'Le numéro de carte est incomplet.',
      expiryIncomplete: "La date d'expiration est incomplète.",
      cvcIncomplete: 'Le cryptogramme est incomplet.',
      cardNumberInvalid: 'Le numéro de carte est invalide.',
      expiryInvalid: "La date d'expiration est invalide.",
      cvcInvalid: 'Le cryptogramme est invalide.',
      cardExpired: 'Votre carte a expiré.',
      cardDeclined: 'Votre carte a été refusée.',
      processingError: 'Une erreur est survenue lors du traitement. Réessayez dans un instant.',
    },
  },
  paymentReturn: {
    pageTitle: 'Confirmation de paiement',
    verifying: 'Vérification de votre paiement…',
    verifyError: 'Impossible de vérifier le paiement.',
    statusCompleted: 'Paiement confirmé',
    statusPending: 'Paiement en attente',
    statusFailed: 'Paiement échoué',
    statusExpired: 'Paiement expiré',
    statusOnSite: 'Paiement sur place',
    successHeading: 'Paiement réussi !',
    successNote: 'Un reçu a été envoyé à votre adresse e-mail.',
    failedHeading: 'Paiement échoué',
    failedNote: 'Votre paiement n’a pas pu être traité. Veuillez réessayer ou contacter le support.',
    pendingHeading: 'Confirmation en cours…',
    pendingNote: 'Cette page se rafraîcht automatiquement.',
    autoRefresh: 'Cette page se rafraîcht automatiquement toutes les quelques secondes.',
    onSiteNote: 'Votre paiement sur place a été enregistré. Le prestataire confirmera la réception avant le début de la prestation.',
    onSiteRegistered: 'Paiement sur place enregistré',
    next1: 'Vous recevrez un e-mail de confirmation sous peu.',
    next2: 'Un prestataire sera assigné à votre demande.',
    next3: 'Vous pouvez suivre votre demande depuis votre profil.',
    retryPayment: 'Réessayer',
    contactSupport: 'Contacter le support',
    backToHome: 'Retour à l’accueil',
    goToProfile: 'Mon profil',
    nextStepsTitle: 'Prochaines étapes',
  },
  wizard: {
    step: 'Étape {{n}}',
    step2Title: 'Titre du projet',
    step2Heading: 'Donnez un titre à votre projet',
    step2Label: 'Titre du projet',
    step2Placeholder: 'Ex. : Rénovation salle de bain — Tunis',
    step2Hint: 'Un titre clair aide les professionnels à comprendre rapidement votre demande.',
    step2Next: 'Suivant',
    step2Back: 'Retour',
    step3Title: 'Détails de la demande',
    step4Title: 'Détails du service',
    step5Title: 'Photos et documents',
    step5Heading: 'Ajoutez des photos ou des documents',
    step5Description: 'Des photos aident les prestataires à mieux comprendre votre besoin et à établir un devis précis.',
    step5Dropzone: 'Cliquez pour ajouter des fichiers',
    step5Hint: 'Images ou PDF — 4 fichiers max, 7 Mo chacun',
    step5FilesSelected: '{{count}} fichier sélectionné',
    step5FilesSelected_plural: '{{count}} fichiers sélectionnés',
    step5MaxFiles: 'Vous pouvez ajouter jusqu\'à 4 fichiers.',
    step5FileTooLarge: '« {{name}} » dépasse la taille maximale de 7 Mo.',
    step6Title: 'Type de prestation',
    step6Heading: 'Quel type de prestation souhaitez-vous ?',
    step6Description: 'Précisez si vous souhaitez que le prestataire prépare un plan avant l\'exécution.',
    step6Question: 'Choisissez une option',
    step6PlanAndExecution: 'Planification + exécution',
    step6ExecutionOnly: 'Exécution uniquement',
    step7Title: 'Lieu d\'intervention',
    step7Heading: 'Où aura lieu la prestation ?',
    step7Description: 'Indiquez la zone d\'intervention pour trouver des prestataires proches de chez vous.',
    step7Region: 'Région',
    step7SelectRegion: 'Sélectionnez une région',
    step7City: 'Ville',
    step7SelectCity: 'Sélectionnez une ville',
    step7ExactAddress: 'Adresse exacte (facultatif)',
    step7AddressPlaceholder: 'Rue, numéro, point de repère…',
    step7PrivacyNote: 'Votre adresse exacte n\'est partagée qu\'avec le prestataire que vous choisirez.',
    step8Title: 'Délai d\'intervention',
    step8Heading: 'Quand souhaitez-vous la prestation ?',
    step8Description: 'Choisissez une date précise ou une date limite.',
    step8DeadlineLabel: 'Échéance souhaitée',
    step8ExactDate: 'À une date précise',
    step8ExactDateWithDate: 'Le {{date}}{{time}}',
    step8ChooseDate: 'Date',
    step8ChooseTime: 'Heure (facultatif)',
    step8TimePrefix: ' à {{time}}',
    step8BeforeDateWithDate: 'Avant le {{date}}{{time}}',
    step8BeforeDatePlain: 'Avant une date limite',
    step8DeadlineDate: 'Date limite',
    step8DeadlineTime: 'Heure limite (facultatif)',
    step9Title: 'Budget et prestataires',
    step9Heading: 'Quel est votre budget ?',
    step9BudgetQuestion: 'Fourchette de budget',
    step9SelectRange: 'Sélectionnez une fourchette',
    step9CustomBudget: 'Ou saisissez votre budget (TND)',
    step9Average: 'Prix moyen constaté :',
    step9SimilarTitle: 'Prestataires similaires',
    step9SimilarDesc: 'Voici des prestataires en {{subService}} ({{parent}}) disponibles{{zone}}.',
    step9SimilarZone: ' dans votre zone ({{zone}})',
    step9LoadingProviders: 'Chargement des prestataires…',
    step9NoProviders: 'Aucun prestataire trouvé pour le moment.',
    step9ViewAllProviders: 'Voir tous les prestataires',
    step9ProviderFallback: 'Prestataire',
    step9OnQuote: 'Sur devis',
    step9ZoneUnknown: 'Zone non précisée',
    step9ReviewsCount: '{{count}} avis',
    step9InterventionFor: 'Intervient pour : {{subService}}',
    step9YearsExperience: '{{years}} ans d\'expérience',
    step9VerifiedProvider: 'Prestataire vérifié',
    step9ViewProfile: 'Voir le profil',
    step9ProvidersError: 'Impossible de charger les prestataires.',
    step10Title: 'Récapitulatif',
    step10Heading: 'Récapitulatif de votre demande',
    step10Description: 'Vérifiez les informations de votre demande avant de l\'envoyer.',
    step10ImageAlt: 'Illustration du service',
    step10ViewDetails: 'Voir les détails',
    step10DefaultTitle: 'Demande de prestation',
    step10ExtraLabel: 'Détails supplémentaires (facultatif)',
    step11Title: 'Vos coordonnées',
    step11Heading: 'Comment vous contacter ?',
    step11Description: 'Laissez votre adresse e-mail pour que les prestataires puissent vous contacter.',
    step11EmailLabel: 'Adresse e-mail',
    step11EmailPlaceholder: 'ex. vous@exemple.com',
    step11PrivacyTitle: 'Visibilité de vos données',
    step11PrivacyPrivate: 'Garder mes informations privées',
    step11PrivacyShare: 'Partager mes informations avec le prestataire choisi',
    step11PrivacyNote: 'Vous pouvez modifier ce choix à tout moment depuis votre profil.',
    step11SaveError: 'Impossible d\'enregistrer votre demande.',
    step11SubmitError: 'Une erreur est survenue lors de l\'envoi.',
    step11Previous: 'Précédent',
    step11Confirm: 'Confirmer et envoyer',
    step11Submitting: 'Envoi en cours…',
    step12Title: 'Confirmation',
    step12Heading: 'Votre demande a bien été soumise !',
    step12Description: 'Voici un récapitulatif de votre demande et les prochaines étapes.',
    step12Confirmed: 'Demande confirmée',
    step12EmailSent: 'Un e-mail de confirmation a été envoyé à {{email}}.',
    step12EmailFallback: 'votre adresse e-mail',
    step12EmailFailed: 'L’e-mail de confirmation n’a pas pu être envoyé.{{error}}',
    step12SpamNote: 'Si vous ne recevez pas l’e-mail, vérifiez vos spams.',
    step12NextSteps: 'Étapes suivantes',
    step12Next1: 'Consultez votre e-mail de confirmation et conservez votre numéro de référence.',
    step12Next2: 'Un prestataire vous contactera pour planifier la prestation.',
    step12Next3: 'Vous pouvez suivre votre demande depuis votre profil à tout moment.',
    step12Next4: 'Finalisez votre paiement pour confirmer la réservation.',
    step12PaymentDescription: '{{parent}} — {{subService}}{{title}}',
    step12Finish: 'Terminer',
    payNow: 'Payer maintenant',
    payNowDialogTitle: 'Confirmer le paiement',
    payNowDialogAmount: 'Montant à régler',
    payNowReminder1: 'Vous serez redirigé vers la page de paiement sécurisée.',
    payNowReminder2: 'Vous recevrez un reçu par e-mail après le paiement.',
    payNowReminder3: 'Le paiement confirme et sécurise votre réservation.',
    payNowCancel: 'Annuler',
    payNowConfirm: 'Confirmer et payer',
    payInfoBanner: 'Sécuriser votre paiement confirme votre réservation — un e-mail de confirmation vous sera envoyé après le paiement.',
  },
  common: {
    back: 'Retour',
    backToHome: 'Retour à l’accueil',
    myProfile: 'Mon profil',
    reference: 'Référence',
    service: 'Service',
    subService: 'Sous-service',
    changeService: 'Changer de service',
    start: 'Commencer',
    next: 'Suivant',
    loading: 'Chargement...',
    retry: 'Réessayer',
    dismiss: 'Ignorer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    save: 'Enregistrer',
    remove: 'Retirer',
    fileSizeMb: '{{size}} Mo',
    fileSizeKb: '{{size}} Ko',
    mapError: 'Impossible de charger la carte.',
    mapRefresh: 'Réessayez en actualisant la page.',
    mapLoading: 'Chargement de la carte…',
    noLocationData: 'Aucune donnée de localisation disponible.',
    providersMustSetLocation: 'Les prestataires doivent définir leur localisation dans leur profil.',
    viewServices: 'Voir les services',
    yourService: 'Votre service',
  },
  subService: {
    pageTitle: '{{name}} — Détails du service',
    intro: 'Découvrez nos professionnels en {{parent}} prêts à vous aider pour ce service.',
    benefit1: 'Professionnels vérifiés et évalués',
    benefit2: 'Qualité garantie ou remboursement',
    benefit3: 'Réponse rapide sous 24 heures',
  },
  auth: {
    loginTitle: 'Connexion à votre compte',
    noAccount: 'Vous n\'avez pas encore de compte?',
    signupLink: 'Inscription',
    signinLink: 'Connexion',
    email: 'Email',
    emailPlaceholder: 'Entrez votre email',
    emailRequired: 'Email est requis',
    emailInvalid: 'Email invalide',
    emailTaken: 'Cet email est déjà utilisé',
    emailAvailable: 'Email disponible',
    emailChecking: 'Vérification de l\'email...',
    password: 'Mot de passe',
    passwordPlaceholder: 'Au moins 8 caractères',
    passwordRequired: 'Mot de passe est requis',
    pwdLower: 'Au moins une minuscule',
    pwdUpper: 'Au moins une majuscule',
    pwdDigit: 'Au moins un chiffre',
    pwdLength: 'Au moins 8 caractères',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oublié?',
    loginButton: 'Connexion à votre compte',
    loggingIn: 'Connexion en cours...',
    loginSuccess: 'Connexion réussie ! Redirection...',
    loginFailed: 'Échec de la connexion',
    loginFailedBody: 'Email ou mot de passe invalide. Veuillez réessayer.',
    orLoginWith: 'ou connectez-vous avec',
    googleLogin: 'Connexion avec Google',
    pageTitle: 'Connexion',
    forgotTitle: 'Mot de passe oublié',
    forgotHeading: 'Mot de passe oublié ?',
    forgotSub: 'Vous ne devriez pas être ici ?',
    sendReset: 'Envoyer le lien de réinitialisation',
    resetSent: 'Un lien de réinitialisation a été envoyé à votre e-mail.',
    resetTitle: 'Réinitialiser le mot de passe',
    resetHeading: 'Réinitialiser le mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    resetButton: 'Réinitialiser',
    resetSubmitting: 'Réinitialisation…',
    resetSuccess: 'Votre mot de passe a été réinitialisé. Vous pouvez vous connecter.',
    resetFailed: 'Impossible de réinitialiser votre mot de passe.',
    resetInvalidLink: 'Ce lien de réinitialisation est invalide ou a expiré.',
    resetDevLink: 'E-mail non envoyé — utilisez ce lien (dev) :',
    forgotSubmitting: 'Envoi…',
    forgotError: 'Impossible d\'envoyer l\'e-mail de réinitialisation.',
    signupTitle: 'Inscription',
    signupHeading: 'Inscription à votre compte',
    signupSub: 'Vous avez déjà un compte ?',
    signupButton: 'S\'inscrire',
    signupGoogle: 'Inscription avec Google',
    signupSubmitting: 'Inscription en cours...',
    signupButtonFull: 'Inscription à votre compte',
    orSignupWith: 'ou inscrivez-vous avec',
    civility: 'Civilité',
    selectCivility: 'Sélectionnez la civilité',
    lastName: 'Nom',
    lastNamePlaceholder: 'Entrez votre nom',
    firstName: 'Prénom',
    firstNamePlaceholder: 'Entrez votre prénom',
    phone: 'Téléphone',
    phonePlaceholder: 'Entrez votre téléphone',
    fixe: 'Fixe',
    fixePlaceholder: 'Entrez votre numéro de fixe',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    confirmPasswordPlaceholder: 'Ressaisissez votre mot de passe',
    role: 'Rôle',
    selectRole: 'Sélectionnez le rôle',
    user: 'Utilisateur',
    client: 'Client',
    provider: 'Prestataire',
    providerType: 'Type de prestataire',
    company: 'Société',
    autoEntrepreneur: 'Auto entrepreneur',
    individual: 'Individuel',
    providerTypeHint: 'Choisissez si vous vous inscrivez en tant que société ou particulier.',
    service: 'Service',
    selectService: 'Sélectionnez le service',
    subService: 'Sous-service',
    selectSubService: 'Sélectionnez le sous-service',
    mainService: 'Service principal',
    serviceN: 'Service {{n}}',
    mainSector: 'Secteur principal',
    sectorN: 'Secteur {{n}}',
    sector: 'Secteur d\'activité',
    selectSector: 'Sélectionnez le secteur',
    subSector: 'Sous-secteur',
    selectSubSector: 'Sélectionnez le sous-secteur',
    remove: 'Retirer',
    add: '+ AJOUTER',
    numCIN: 'Numéro CIN',
    cinPhoto: 'Photo CIN (vérification IA)',
    cinHint: 'Téléchargez une photo claire de la CIN pour la vérification automatique.',
    docsAuto: 'Documents de vérification (auto entrepreneur)',
    docsCompany: 'Documents de vérification (société)',
    docsHint: 'Téléchargez les documents nécessaires pour vérifier votre identité (pièce d\\',
    docsCompanyHint: 'Téléchargez les documents nécessaires pour vérifier qu\\',
    filesSelected: '{{count}} fichier(s) : {{names}}',
    creationYear: 'Année de création',
    siret: 'Numéro d\'immatriculation (SIRET)',
    siretPlaceholder: 'Entrez votre numéro SIRET',
    vatNumber: 'Numéro de TVA',
    vatPlaceholder: 'Entrez votre numéro de TVA',
    region: 'Région',
    selectRegion: 'Sélectionnez la région',
    city: 'Ville',
    selectCity: 'Sélectionnez la ville',
    address: 'Adresse',
    addressPlaceholder: 'Entrez votre adresse',
    socialNetworks: 'Réseaux sociaux (optionnel)',
    website: 'Site web',
    cinPlaceholder: 'Ex. : 12345678',
    creationYearPlaceholder: 'Ex. : 2015',
  
    errors: {
      lastNameRequired: 'Nom est requis',
      firstNameRequired: 'Prénom est requis',
      emailRequired: 'Email est requis',
      emailInvalid: 'Email invalide',
      phoneRequired: 'Téléphone est requis',
      phoneDigits: 'Le téléphone doit contenir 8 chiffres',
      fixeRequired: 'Fixe est requis',
      fixeDigits: 'Le numéro fixe doit contenir 8 chiffres',
      passwordRequired: 'Mot de passe est requis',
      confirmPasswordRequired: 'Confirmer le mot de passe est requis',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      roleRequired: 'Rôle est requis',
      regionRequired: 'La région est requise',
      cityRequired: 'La ville est requise',
      addressRequired: 'Adresse est requise',
      serviceRequired: 'Veuillez sélectionner au moins un service ou secteur d\'activité',
      subServiceRequired: 'Veuillez sélectionner un sous-service pour « {{sect}} » (ligne {{line}}).',
      selectService: 'Veuillez sélectionner au moins un service.',
      passwordMismatch2: 'Les mots de passe ne correspondent pas',
      registrationFailed: 'L\'inscription a échoué. Veuillez réessayer.',
      serverConnectionError: 'Impossible de se connecter au serveur. Vérifiez que le serveur backend est démarré sur le port 5001.',
      registrationSuccessProvider: 'Inscription réussie. Vous pouvez vous connecter avec vos identifiants.',
      registrationSuccessClient: 'Inscription réussie.',
    },
  },
  userRequest: {
    pageTitle: 'Publier une demande',
    pageSubtitle: 'Sélectionnez les services dont vous avez besoin et soumettez votre demande. Nous vous mettrons en relation avec les bons prestataires.',
    loadError: 'Échec du chargement des services. Veuillez réessayer plus tard.',
    selectOneService: 'Veuillez sélectionner au moins un service.',
    enterEmail: 'Veuillez saisir votre adresse e-mail.',
    availableServices: 'Services disponibles',
    selectHint: 'Cliquez sur un service pour le sélectionner. Vous pouvez choisir plusieurs services.',
    selectedTitle: 'Services sélectionnés',
    submitSuccess: 'Demande soumise avec succès ! Redirection...',
    submitError: 'Échec de l\'envoi de la demande.',
    yourEmail: 'Votre e-mail',
    yourName: 'Votre nom (optionnel)',
    yourPhone: 'Votre téléphone (optionnel)',
    notes: 'Notes supplémentaires (optionnel)',
    notesPlaceholder: 'Tout détail sur votre demande...',
    submit: 'Soumettre la demande',
    submitting: 'Envoi en cours...',
  },
  postRequest: {
    heading: 'Devenir un prestataire',
    subheading: 'Indiquez votre informations de prestation.',
    contacting: 'Vous contactez :',
    theProvider: 'le prestataire',
    about: 'À propos',
    aboutPlaceholder: 'Décrivez votre besoin : contexte, attentes, détails importants...',
    service: 'Service',
    selectService: 'Sélectionnez un service',
    loadingServices: 'Chargement des services...',
    subService: 'Sous-service',
    selectSubService: 'Selectionnez un sous-service',
    availability: 'Disponibilité',
    day: 'Jour',
    available: 'Disponible',
    from: 'De',
    to: 'À',
    scheduleHint: 'Cochez "Disponible" et indiquez les heures pour chaque jour.',
    scheduleNotes: 'Remarques horaires',
    scheduleNotesPlaceholder: 'Ex. : Sur rendez-vous le week-end, disponibilité variables...',
    interventionRegion: "Zone d'intervention - Région",
    selectRegion: 'Selectionnez une région',
    interventionCity: "Zone d'intervention - Ville",
    selectCity: 'Selectionnez une ville',
    experience: 'Expérience',
    yearsExp: "Nombre d'années d'expérience",
    choose: 'Choisir',
    projectsCompleted: 'Projets réalisés',
    projectsPlaceholder: 'Ex: 120',
    previousCompanies: 'Entreprises précédentes (optionnel)',
    previousCompaniesPlaceholder: 'Ex: Entreprise A, Entreprise B...',
    pricing: 'Tarification',
    hourlyPrice: 'Prix par heure',
    hourlyPricePlaceholder: 'Ex: 30 TND/h',
    dailyPrice: 'Prix par jour',
    dailyPricePlaceholder: 'Ex: 100 TND/jour',
    customQuote: 'Devis personnalisé',
    customQuotePlaceholder: 'Conditions de devis personnalisé...',
    portfolio: 'Portfolio',
    photos: 'Photos avant / après (liens ou description)',
    photosPlaceholder: 'Collez des liens ou décrivez les photos...',
    photosCount: '{{count}} photo(s) sélectionnée(s)',
    projectsPortfolio: 'Projets réalisés (portfolio)',
    projectsPortfolioPlaceholder: 'Liste des projets réalisés...',
    projectsCount: '{{count}} fichier(s) projet sélectionné(s)',
    videos: 'Vidéos (optionnel)',
    videosPlaceholder: 'Liens vidéos (YouTube, Drive, etc.)',
    videosCount: '{{count}} vidéo(s) sélectionnée(s)',
    clientCommitments: 'Engagements clients',
    clientCommitmentsPlaceholder: 'Ex. : réponses sous 24h, accès au chantier, disponibilité pour rendez-vous...',
    paymentMethod: 'Méthode de paiement',
    paymentMethods: {
      card: 'Carte bancaire',
      transfer: 'Virement bancaire',
      cash: 'Espèces',
      online: 'Paiement en ligne',
      check: 'Chèque',
      other: 'Autre',
    },
    coverageGuarantees: 'Couvertures et garanties',
    coveragePlaceholder: 'Ex. : garantie 12 mois, responsabilité civile, assurance dégâts...',
    backToServices: '← Retour aux services',
    submit: 'Envoyer la demande',
    submitting: 'Envoi en cours...',
    tradeRequired: 'Veuillez sélectionner un métier.',
    submitFailed: 'Envoi échoué.',
    genericError: 'Une erreur est survenue.',
    successMsg: 'Demande enregistrée. Redirection...',
    days: {
      lun: 'Lundi', mar: 'Mardi', mer: 'Mercredi', jeu: 'Jeudi',
      ven: 'Vendredi', sam: 'Samedi', dim: 'Dimanche',
    },
    closed: 'Fermé',
  },
  contactPage: {
    needSupport: 'Besoin d\'aide',
    title: 'Contactez-nous',
    desc: 'Contactez-nous pour toute question ou assistance. Notre équipe dévouée est prête à vous aider et à vous proposer les meilleures solutions.',
    billingPayments: 'Facturation & Paiements',
    billingDesc: 'Gérez votre facturation et vos paiements facilement avec notre plateforme intuitive. Suivez vos transactions financières et assurez des processus de paiement fluides et sécurisés.',
    seePricingQuestions: 'Voir les questions de tarification',
    usersCollab: 'Utilisateurs et collaboration',
    usersDesc: 'Connectez-vous et collaborez avec les utilisateurs sur notre plateforme. Partagez des informations, assignez des tâches et travaillez ensemble efficacement.',
    allDocs: 'Toutes les documentations',
    afterSales: 'Service après-vente',
    afterSalesDesc: 'Réclamation, remboursement, retour produit, garantie, suivi d\'intervention, support client, évaluation d\'un prestataire, signalement… Notre équipe SAV vous accompagne et suit chaque ticket jusqu\'à résolution.',
    openSavTicket: 'Ouvrir un ticket SAV',
    contactSupport: 'Contacter le support',
    getInTouch: 'Prenez contact',
    getInTouchDesc: 'Contactez-nous pour une assistance personnalisée. Nous sommes là pour vous aider et fournir des solutions adaptées à vos besoins.',
    plansPricing: 'Formules & Tarifs',
    plansDesc: 'Choisissez parmi nos formules flexibles et nos options de tarification compétitives pour trouver la meilleure adaptation à vos besoins et votre budget.',
    seePricing: 'Voir les tarifs',
    faq: 'Questions fréquentes',
    faqDesc: 'Trouvez les réponses aux questions les plus courantes sur notre produit ou service dans notre section FAQ complète.',
    seeAllQuestions: 'Voir toutes les questions',
    ctaTitle: 'Suivez vos analyses utilisateur pour booster votre entreprise',
    getStarted: 'Commencer',
    pricingPlans: 'Tarifs & Formules',
    newsletterTitle: 'Abonnez-vous à notre newsletter',
    newsletterDesc: 'Rejoignez les 5000+ personnes qui utilisent les produits Allo Alla.',
  },
  providerSettings: {
    pageTitle: 'Espace prestataire',
    heading: 'Espace prestataire',
    subheading: 'Consultez et modifiez votre offre de prestation : services, tarifs, zone d\'intervention, etc.',
    back: 'Retour',
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    saved: 'Prestation enregistrée.',
    loading: 'Chargement…',
    serviceTrade: 'Service / Métier',
    selectService: 'Sélectionnez un service',
    sector: 'Secteur',
    choose: 'Choisir',
    subSector: 'Sous-secteur',
    regionZone: 'Région (zone)',
    cityZone: 'Ville (zone)',
    skills: 'Compétences',
    skillsPlaceholder: 'Ex: Plomberie, Installation sanitaire, Dépannage…',
    addSkill: 'Ajouter',
    removeSkill: 'Supprimer',
    experience: 'Expérience',
    qualifications: 'Qualifications',
    description: 'Description',
    pricing: 'Tarification',
    zoneDetail: "Zone d'intervention (détail)",
    zonePlaceholder: 'Rayon, communes couvertes, conditions…',
    schedule: 'Disponibilité (planning)',
    prestationInfo: 'Informations de prestation',
    prestationNote: 'Pour votre identité et vos coordonnées, utilisez la page',
    profile: 'Profil',
    rows: {
      trade: 'Métier',
      sector: 'Secteur',
      subSector: 'Sous-secteur',
      skills: 'Compétences',
      experience: 'Expérience',
      qualifications: 'Qualifications',
      description: 'Description',
      zone: "Zone d'intervention",
      pricing: 'Tarification',
      schedule: 'Disponibilité',
    },
  },
  admin: {
    pageTitle: 'Dashboard Admin',
    heading: 'Dashboard Admin',
    subheading: 'Pilotage de la plateforme (utilisateurs, demandes, categories, stats).',
    backToProfile: 'Retour profil',
    loading: 'Chargement...',
    errorLoading: 'Erreur de chargement.',
    savLoadFailed: 'Chargement SAV échoué.',
    paymentsLoadFailed: 'Chargement paiements echoue.',
    ticketUpdated: 'Ticket mis à jour.',
    ticketUpdateFailed: 'Mise à jour SAV échouée.',
    replyFailed: 'Envoi du message échoué.',
    deleteTicketConfirm: 'Supprimer ce ticket SAV ?',
    ticketDeleted: 'Ticket supprimé.',
    deleteFailed: 'Suppression échouée.',
    saveConfirm: 'Enregistrer les modifications ?',
    accountUpdated: 'Compte mis a jour.',
    updateFailed: 'Mise a jour echouee.',
    deleteUserConfirm: 'Supprimer {{email}} ?',
    userDeleted: 'Utilisateur supprime.',
    deleteFailed2: 'Suppression echouee.',
    createFieldsRequired: 'Nom, email et mot de passe sont requis pour ajouter un utilisateur.',
    userAdded: 'Utilisateur ajoute avec succes.',
    userAddFailed: "Ajout de l'utilisateur echoue.",
    menu: {
      users: '1. Gestion des utilisateurs',
      stats: '2. Statistiques',
      requests: '3. Gestion des demandes',
      categories: '4. Catégories de services',
      reviews: '5. Avis & commentaires',
      outreach: '6. Messages contact & blog',
      payments: '7. Paiements & transactions',
      support: '8. Support & reclamations',
      settings: '9. Parametres du site',
      system: '10. Système & connexions',
    },
    system: {
      title: 'Système & connexions',
      statusTitle: 'État du système',
      refresh: 'Rafraîchir',
      serverLabel: 'Serveur API',
      dbLabel: 'Base de données',
      stripeLabel: 'Stripe (paiements)',
      emailLabel: 'Email',
      up: 'En ligne',
      down: 'Injoignable',
      connected: 'Connectée',
      disconnected: 'Déconnectée',
      connecting: 'Connexion…',
      configured: 'Configuré',
      notConfigured: 'Non configuré',
      apiTitle: 'Serveur API (backend)',
      apiDesc: 'Adresse utilisée par le frontend pour joindre le backend (contenu du site, images, logo).',
      apiLabel: 'URL du serveur API',
      apiCurrent: 'URL actuelle',
      apiOverride: 'Personnalisée',
      apiDefault: 'Par défaut (env)',
      apiPlaceholder: 'ex. http://localhost:5013/api',
      apiTest: 'Tester',
      apiApply: 'Appliquer',
      apiReset: 'Réinitialiser',
      apiTestOk: 'Connexion au serveur réussie',
      apiTestFail: 'Échec de connexion au serveur',
      apiApplied: 'URL API appliquée. Rechargez la page pour recharger tout le contenu.',
      apiResetDone: 'Override supprimé — URL par défaut restaurée.',
      apiInvalid: 'URL invalide (ex. http://localhost:5013/api)',
      dbTitle: 'Base de données (MongoDB)',
      dbDesc: 'URI utilisée par le backend. Enregistrée dans backend/.env et appliquée sans redémarrage.',
      dbCurrent: 'URI actuelle',
      dbPlaceholder: 'mongodb://localhost:27017/alo-alla',
      dbTest: 'Tester la connexion',
      dbApply: 'Appliquer & reconnecter',
      dbTestOk: 'Connexion réussie',
      dbTestFail: 'Échec de connexion',
      dbApplyConfirm: 'Changer la connexion MongoDB maintenant ? Le backend se reconnectera immédiatement.',
      dbApplied: 'Base de données mise à jour et reconnectée.',
    },
    config: {
      title: 'Configuration plateforme',
      desc: 'Tous les réglages du backend (clés Stripe, e-mail, URLs, sécurité) — enregistrés dans backend/.env et appliqués immédiatement, sans redémarrage.',
      save: 'Enregistrer la configuration',
      saved: 'Configuration enregistrée et appliquée.',
      saveFailed: "Échec de l'enregistrement",
      nothingToSave: 'Aucune modification à enregistrer.',
      remove: 'Supprimer cette valeur',
      danger: 'Sensible',
      secretSet: 'configuré (masqué)',
      notSet: 'non configuré',
      secretKeep: 'Laisser vide pour conserver la valeur actuelle.',
      secretEmpty: 'Non défini — saisir une valeur pour configurer.',
      visibleEmpty: 'Vider le champ pour supprimer la variable (valeur par défaut appliquée).',
      jwtWarning: 'Modifier ce secret invalide toutes les sessions connectées.',
      testEmail: 'Envoyer un e-mail de test',
      testEmailTo: 'Destinataire du test',
      testEmailOk: 'E-mail de test envoyé.',
      testEmailFail: "Échec de l'envoi du test",
      testStripe: 'Tester la connexion Stripe',
      testStripeOk: 'Connexion Stripe réussie.',
      testStripeFail: 'Échec du test Stripe',
      stripeTitle: 'Stripe — paiements',
      stripeHint: 'Clés du Dashboard Stripe (Dashboard → Développeurs → Clés API / Webhooks).',
      emailTitle: 'E-mail — Brevo',
      emailHint: "Clés Brevo (SMTP & API). La clé API commence par xkeysib-, la clé SMTP par xsmtpsib-.",
      smtpTitle: 'E-mail — SMTP générique (optionnel)',
      smtpHint: 'Utilisé seulement si Brevo n\'est pas configuré.',
      urlsTitle: 'URLs',
      urlsHint: 'URLs utilisées pour les liens e-mails, redirections Stripe et CORS.',
      authTitle: 'Authentification',
      authHint: 'Sécurité des sessions — à modifier avec précaution.',
      fields: {
        STRIPE_SECRET_KEY: 'Clé secrète Stripe',
        STRIPE_PUBLISHABLE_KEY: 'Clé publique Stripe',
        STRIPE_WEBHOOK_SECRET: 'Secret webhook Stripe',
        STRIPE_CURRENCY: 'Devise Stripe',
        STRIPE_TLS_REJECT_UNAUTHORIZED: 'Stripe : ignorer certificat TLS',
        BREVO_API_KEY: 'Clé API Brevo',
        BREVO_SMTP_KEY: 'Clé SMTP Brevo',
        BREVO_SMTP_LOGIN: 'Login SMTP Brevo',
        BREVO_SENDER_EMAIL: 'E-mail expéditeur',
        BREVO_SENDER_NAME: "Nom de l'expéditeur",
        EMAIL_FROM: 'Expéditeur complet (From)',
        SMTP_HOST: 'Hôte SMTP',
        SMTP_PORT: 'Port SMTP',
        SMTP_USER: 'Utilisateur SMTP',
        SMTP_PASS: 'Mot de passe SMTP',
        SMTP_TLS_REJECT_UNAUTHORIZED: 'SMTP : ignorer certificat TLS',
        FRONTEND_URL: 'URL du site (frontend)',
        PUBLIC_BACKEND_URL: 'URL publique du backend',
        CORS_ORIGINS: 'Origines CORS autorisées',
        JWT_SECRET: 'Secret JWT',
        AUTH_TOKEN_TTL: 'Durée des sessions',
      },
      placeholder: {
        STRIPE_PUBLISHABLE_KEY: 'pk_test_…',
        STRIPE_CURRENCY: 'eur',
        STRIPE_TLS_REJECT_UNAUTHORIZED: 'false',
        BREVO_SMTP_LOGIN: 'abc123@smtp-brevo.com',
        BREVO_SENDER_EMAIL: 'noreply@votre-domaine.com',
        BREVO_SENDER_NAME: 'Alo Alla',
        EMAIL_FROM: 'Alo Alla <noreply@votre-domaine.com>',
        SMTP_HOST: 'smtp.exemple.com',
        SMTP_PORT: '587',
        SMTP_USER: 'utilisateur@exemple.com',
        SMTP_TLS_REJECT_UNAUTHORIZED: 'true',
        FRONTEND_URL: 'https://www.votre-site.com',
        PUBLIC_BACKEND_URL: 'https://api.votre-site.com',
        CORS_ORIGINS: 'https://www.votre-site.com, https://votre-site.com',
        AUTH_TOKEN_TTL: '12h',
      },
    },
    settings: {
      title: 'Parametres du site',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      saved: 'Parametres enregistres avec succes.',
      saveFailed: 'Echec de la sauvegarde.',
      loadFailed: 'Echec du chargement des parametres.',
      companyTitle: 'Informations entreprise',
      companyName: 'Nom de la societe',
      tagline: 'Slogan / description',
      contactTitle: 'Coordonnees',
      contactEmail: 'Adresse e-mail',
      contactPhone: 'Telephone',
      contactAddress: 'Adresse',
      socialTitle: 'Reseaux sociaux',
      footerTitle: 'Pied de page',
      copyright: 'Texte de copyright (optionnel)',
      copyrightPlaceholder: 'ex. Tous droits reserves.',
      termsUrl: "URL conditions d'utilisation",
      privacyUrl: 'URL politique de confidentialite',
    },
    users: {
      listTitle: 'Liste des utilisateurs (clients + prestataires)',
      seedMissing: 'Créer comptes démo (manquants)',
      recreateDemo: 'Recréer comptes démo',
      seedConfirm: 'Supprimer puis recréer uniquement les comptes aux emails demo-*@nioland.local ? Les autres utilisateurs ne sont pas touchés.',
      demoUpdated: 'Comptes démo mis à jour.',
      demoCreateFailed: 'Échec création comptes démo.',
      demoRecreated: 'Comptes démo recréés.',
      demoRecreateFailed: 'Échec recréation comptes démo.',
      refAccounts: 'Comptes de référence :',
      refAccountsDesc: 'demo-admin@nioland.local (Admin123!), demo-client@nioland.local (Client123!), demo-prestataire@nioland.local (Prestataire123!). À usage développement / démo uniquement.',
      addUser: 'Ajouter un utilisateur',
      firstName: 'Prenom',
      lastName: 'Nom',
      role: 'Role',
      email: 'Email',
      password: 'Mot de passe',
      phone: 'Telephone',
      user: 'utilisateur',
      provider: 'prestataire',
      adding: 'Ajout...',
      addUserBtn: 'Ajouter utilisateur',
      thName: 'Nom',
      thEmail: 'Email',
      thPhone: 'Telephone',
      thRole: 'Role',
      thActive: 'Actif',
      thVerifStatus: 'Statut verif.',
      thIaDocs: 'IA docs',
      thActions: 'Actions',
      closeAdd: 'Fermer ajout',
      add: 'Ajouter',
      edit: 'Modifier',
      delete: 'Supprimer',
      editFormTitle: 'Formulaire modification',
      clickEdit: 'Cliquez sur "Modifier".',
      account: 'Compte:',
      editRole: 'Role',
      verifStatus: 'Statut verif.',
      notes: 'Notes',
      accountActive: 'Compte actif',
      saving: 'Enregistrement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
    },
    stats: {
      users: 'Users',
      jobs: 'Jobs',
      completed: 'Prestations realisees',
      revenue: 'Revenus (estimes)',
    },
    requests: {
      title: 'Gestion des demandes',
      thClient: 'Client',
      thService: 'Service',
      thSubService: 'Sous-service',
      thStatus: 'Statut',
      thPrice: 'Prix',
    },
    categories: {
      title: 'Catégories de services',
      desc: 'Consultez tous les services et gérez leurs catégories. Les catégories sont les sous-secteurs que les prestataires choisissent lors de leur inscription.',
      overviewTitle: 'Tous les services',
      overviewDesc: 'Voici tous les services de votre plateforme. Chaque service peut avoir plusieurs catégories.',
      refresh: 'Rafraîchir',
      initDefaults: 'Synchroniser avec les services par défaut',
      syncing: 'Synchronisation...',
      synced: 'Services synchronisés avec les données par défaut.',
      initFailed: 'Initialisation des services échouée.',
      recreate: 'Réinitialiser tous les services',
      recreating: 'Réinitialisation...',
      recreateConfirm: 'Cela supprimera tous les services actuels et les remplacera par la liste par défaut. Les prestataires devront mettre à jour leur métier dans leur profil. Continuer ?',
      recreated: 'Services réinitialisés.',
      recreateFailed: 'Échec de la réinitialisation des services.',
      noServices: 'Aucun service trouvé.',
      thTitle: 'Nom du service',
      thUrl: 'URL',
      thCategories: 'Catégories',
      thProviders: 'Prestataires',
      thId: 'ID (_id)',
      manageCats: 'Gérer les catégories',
      manageCatsDesc: 'Sélectionnez un service ci-dessous pour ajouter, renommer ou supprimer ses catégories.',
      service: 'Service',
      addCategory: 'Ajouter une nouvelle catégorie',
      categoryPlaceholder: 'Ex: Pose plan de travail',
      adding: 'Ajout...',
      addBtn: 'Ajouter',
      addFailed: 'Ajout de catégorie échoué.',
      selectService: 'Sélectionnez un service.',
      noCategories: 'Aucune catégorie pour ce service.',
      thCategory: 'Catégorie',
      edit: 'Modifier',
      savingShort: 'Enreg...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      editFailed: 'Modification échouée.',
      delete: 'Supprimer',
      deleteConfirm: 'Supprimer la catégorie "{{name}}" ?',
      deleteFailed: 'Suppression échouée.',
    },
    services: {
      validation: {
        titleRequired: 'Le titre est requis.',
        titleTooLong: 'Le titre est trop long.',
        descriptionTooLong: 'La description est trop longue.',
        invalidUrl: 'URL invalide.',
      },
      title: 'Gestion des services',
      addNew: 'Ajouter un service',
      deleteSelected: 'Supprimer la sélection',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce service ?',
      bulkDeleteTitle: 'Suppression en masse des services',
      bulkDeleteConfirm: 'Êtes-vous sûr de vouloir supprimer {{count}} services ? Cette action ne peut pas être annulée.',
      andMore: '...et {{count}} autres',
      noServices: 'Aucun service trouvé',
      noServicesDesc: 'Créez votre premier service pour commencer',
      showing: 'Affichage de {{count}} services',
      selected: '{{count}} sélectionné(s)',
      thTitle: 'Titre',
      thDescription: 'Description',
      thCategories: 'Catégories',
      thCover: 'Image',
      thSlug: 'Slug',
      thSubServices: 'Sous-services',
      thStatus: 'Statut',
      thCreated: 'Créé le',
      thActions: 'Actions',
      active: 'Actif',
      inactive: 'Inactif',
      hasImage: 'A une image',
      activate: 'Activer',
      deactivate: 'Désactiver',
      edit: 'Modifier le service',
      createSuccess: 'Service créé avec succès.',
      updateSuccess: 'Service mis à jour avec succès.',
      deleteSuccess: 'Service supprimé avec succès.',
      filters: {
        title: 'Filtres',
        reset: 'Réinitialiser',
        search: 'Rechercher',
        searchPlaceholder: 'Rechercher par titre ou description...',
        searchHelp: 'Rechercher dans les titres et descriptions des services',
        category: 'Catégorie',
        allCategories: 'Toutes les catégories',
        status: 'Statut',
        allStatus: 'Tous les statuts',
        sortBy: 'Trier par',
        sortOrder: 'Ordre',
        active: 'Filtres actifs',
        sortByOptions: {
          created: 'Date de création',
          title: 'Titre',
          status: 'Statut'
        },
        sortOrderOptions: {
          desc: 'Décroissant',
          asc: 'Croissant'
        }
      },
      form: {
        title: 'Titre',
        titlePlaceholder: 'Entrez le titre du service',
        titleHelp: 'Maximum 100 caractères',
        description: 'Description',
        descriptionPlaceholder: 'Entrez la description du service',
        descriptionHelp: 'Maximum 1000 caractères',
        cover: 'URL de l\'image de couverture',
        coverPlaceholder: 'https://exemple.com/image.jpg',
        coverHelp: 'Optionnel : URL vers l\'image de couverture du service',
        tags: 'Étiquettes',
        tagsPlaceholder: 'tag1, tag2, tag3',
        tagsHelp: 'Liste d\'étiquettes séparées par des virgules',
        categories: 'Catégories',
        categoriesPlaceholder: 'catégorie1, catégorie2, catégorie3',
        categoriesHelp: 'Liste de catégories séparées par des virgules',
        subServices: 'Sous-services',
        subServicesHelp: 'Ajoutez des tuiles de sous-services avec une clé, un libellé optionnel et un chemin d\'image.',
        addSubService: 'Ajouter un sous-service',
        subServiceKey: 'Clé (ex: plomberie)',
        subServiceLabel: 'Libellé (optionnel, fallback i18n)',
        subServiceCover: 'Chemin image (ex: /images/plomberie.jpg)',
        featured: 'En vedette',
        noSubServices: 'Aucun sous-service ajouté.',
        untitled: 'Sans titre',
        description: 'Description',
        descriptionFrPlaceholder: 'Description en français...',
        descriptionEnPlaceholder: 'Description en anglais...',
        itemsList: 'Liste des avantages / caractéristiques',
        addItem: 'Ajouter un élément',
        itemFrPlaceholder: 'Élément en français',
        itemEnPlaceholder: 'Élément en anglais',
        browse: 'Parcourir',
        imagePicker: 'Sélectionner une image',
        searchImages: 'Rechercher des images...',
        currentImage: 'Image actuelle :',
        noImagesFound: 'Aucune image trouvée.',
        tabGeneral: 'Général',
        tabCategories: 'Catégories',
        tabSubServices: 'Sous-services',
        tabRouting: 'Routage & SEO',
        tabLibrary: 'Bibliothèque',
        tabUpload: 'Téléverser',
        labelFr: 'Libellé (Français)',
        labelEn: 'Libellé (Anglais)',
        labelFrPlaceholder: 'ex: Plomberie',
        labelEnPlaceholder: 'ex: Plumbing',
        dropOrClick: 'Déposez une image ici ou cliquez pour parcourir',
        uploadHelp: 'JPG, PNG, GIF, WebP, SVG — max 10 Mo',
        uploading: 'Téléversement...',
        uploadFailed: 'Échec du téléversement. Veuillez réessayer.',
        previewUrl: 'Aperçu URL :',
        categoriesHelp: 'Ajoutez des catégories pour grouper ce service sur la plateforme.',
        manage: 'Gérer',
        editCategory: 'Modifier la catégorie',
        categoryName: 'Nom de la catégorie',
        subServicesInCategory: 'Sous-services dans cette catégorie',
        uncategorizedSubs: 'Sous-services non catégorisés',
        uncategorizedHelp: 'Sous-services non liés à une catégorie. Assignez-les depuis la boîte de dialogue d\'une catégorie.',
        slug: 'Slug URL',
        slugPlaceholder: 'ex: plomberie-chauffage',
        slugHelp: 'Utilisé dans l\'URL: /services/votre-slug',
        subtitle: 'Sous-titre de la page',
        subtitlePlaceholder: 'Description courte affichée sur la page catégorie',
        tilePrefix: 'Préfixe CSS des tuiles',
        tilePrefixPlaceholder: 'ex: plumbing',
        tilePrefixHelp: 'Préfixe de classe CSS pour le style des tuiles (optionnel)',
        url: 'URL',
        isActive: 'Le service est actif',
        isActiveHelp: 'Les services inactifs ne seront pas affichés aux utilisateurs',
        create: 'Créer le service',
        creating: 'Création...',
        update: 'Mettre à jour le service',
        updating: 'Mise à jour...',
        validation: {
          titleRequired: 'Le titre est requis',
          titleTooLong: 'Le titre doit faire moins de 100 caractères',
          descriptionTooLong: 'La description doit faire moins de 1000 caractères',
          invalidUrl: 'Veuillez entrer une URL valide',
          invalidJson: 'Format JSON invalide'
        }
      }
    },
    reviews: {
      title: 'Avis & commentaires',
      desc: 'Retours enregistrés sur les demandes (note moyenne, commentaires) et tickets SAV d\'évaluation prestataire.',
      withReviews: 'Demandes avec avis / commentaires',
      thClient: 'Client',
      thService: 'Service',
      thRating: 'Note',
      thComment: 'Commentaire',
      thDate: 'Date',
      noReviews: 'Aucune donnée d\'avis sur les demandes.',
      providerReviews: 'Avis clients sur les prestataires',
      thProvider: 'Prestataire',
      noProviderReviews: 'Aucun avis publié sur les prestataires.',
      savEvaluations: 'Évaluations (tickets SAV)',
      loadingTickets: 'Chargement des tickets…',
      thSubject: 'Sujet',
      thStatus: 'Statut',
      noEvalTickets: 'Aucun ticket d\'évaluation.',
    },
    outreach: {
      title: 'Messages contact & blog (MongoDB)',
      refresh: 'Rafraîchir',
      contacts: 'Formulaires contact',
      contactsDesc: 'Collection',
      thDate: 'Date',
      thName: 'Nom',
      thEmail: 'Email',
      thSubject: 'Sujet',
      thMessage: 'Message',
      noMessages: 'Aucun message.',
      blogArticles: 'Articles blog (API)',
      blogDesc: 'Collection',
      thTitle: 'Titre',
      thAuthor: 'Auteur',
      thCategory: 'Catégorie',
      noArticles: 'Aucun article.',
    },
    support: {
      title: 'Support & SAV (réclamations, garanties, remboursements…)',
      totalTickets: 'Total tickets',
      pending: 'En attente',
      inProgress: 'En cours',
      resolved: 'Résolus',
      byType: 'Répartition par type de demande',
      filterStatus: 'Statut',
      all: 'Tous',
      filterType: 'Type',
      refresh: 'Rafraîchir',
      loading: 'Chargement…',
      noTickets: 'Aucun ticket pour ces filtres.',
      thDate: 'Date',
      thClient: 'Client',
      thType: 'Type',
      thSubject: 'Sujet',
      thStatus: 'Statut',
      thPriority: 'Priorité',
      thAgent: 'Agent',
      thMessages: 'Échanges',
      thActions: 'Actions',
      manage: 'Gérer',
      deleteShort: 'Suppr.',
      ticket: 'Ticket',
      customer: 'Client',
      createdOn: 'Créé le',
      provider: 'Prestataire',
      reference: 'Référence',
      rating: 'Note',
      initialDesc: 'Description initiale',
      attachments: 'Pièces jointes',
      attachment: 'Pièce',
      status: 'Statut',
      priority: 'Priorité',
      assignedAgent: 'Agent assigné',
      agentPlaceholder: 'Ex: agent@nioland',
      saving: 'Enregistrement…',
      save: 'Enregistrer',
      history: 'Historique des échanges',
      noMessages: 'Aucun message.',
      replyToCustomer: 'Répondre au client',
      replyPlaceholder: 'Votre réponse…',
      sending: 'Envoi…',
      sendReply: 'Envoyer la réponse',
      close: 'Fermer',
    },
    payments: {
      title: 'Paiements & transactions Stripe',
      payments: 'Paiements',
      completed: 'Reussis',
      pending: 'En attente',
      revenue: 'Encaissements (TND)',
      filterStatus: 'Statut',
      all: 'Tous',
      refresh: 'Rafraichir',
      loading: 'Chargement…',
      noPayments: 'Aucun paiement pour ce filtre.',
      thDate: 'Date',
      thClient: 'Client',
      thAmount: 'Montant',
      thCurrency: 'Devise',
      thDescription: 'Description',
      thMethod: 'Methode',
      thStatus: 'Statut',
      thStripeRef: 'Ref Stripe',
      onSite: 'Sur place',
      card: 'Carte',
    },
    savTypes: {
      reclamation: 'Réclamation',
      remboursement: 'Demande de remboursement',
      'retour-produit': 'Retour produit',
      garantie: 'Garantie',
      'assistance-technique': 'Assistance technique',
      'suivi-intervention': 'Suivi d\'intervention',
      'support-client': 'Support client',
      'evaluation-prestataire': 'Évaluation du prestataire',
      'signalement-probleme': 'Signalement de problème',
      historique: 'Historique commandes/interventions',
    },
    savStatus: {
      pending: 'En attente',
      'in-progress': 'En cours',
      resolved: 'Résolu',
    },
    savPriorities: {
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Haute',
    },
  },
  profile: {
    pageTitle: 'Mon profil',
    accountTitle: 'Mon compte',
    loading: 'Chargement de votre profil…',
    profileTitle: 'Mon profil',
    home: 'Accueil',
    afterSales: 'Service après-vente',
    pay: 'Effectuer un paiement',
    myPaymentsTitle: 'Historique de mes paiements',
    myPayments: 'Mes paiements',
    noPayments: 'Aucun paiement pour l’instant. Réglez une prestation pour voir votre historique ici.',
    makePayment: 'Effectuer un paiement',
    paymentDate: 'Date',
    paymentDesc: 'Description',
    paymentStatus: 'Statut',
    paymentAmount: 'Montant',
    viewAllPayments: 'Effectuer un nouveau paiement',
    paymentsLoading: 'Chargement des paiements…',
    paymentsError: 'Impossible de charger l’historique des paiements.',
    providerSpace: 'Espace prestataire',
    adminDashboard: 'Dashboard admin',
    editProfile: 'Modifier mon profil',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement…',
    logout: 'Déconnexion',
    changePhoto: 'Changer la photo',
    addPhoto: 'Ajouter une photo',
    profilePicture: 'Photo de profil',
    registeredOn: 'Inscrit le',
    identity: 'Identité',
    roleAndType: 'Rôle et type',
    location: 'Localisation',
    providerInfo: 'Informations prestataire',
    socialNetworks: 'Réseaux sociaux et web',
    civility: 'Civilité',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    role: 'Rôle',
    providerType: 'Type de prestataire',
    region: 'Région',
    city: 'Ville',
    address: 'Adresse',
    locationLabel: 'Localisation',
    sector: 'Secteur d\'activité',
    subSector: 'Sous-secteur',
    creationYear: 'Année de création',
    registrationNumber: 'Numéro d\'immatriculation (SIRET)',
    vatNumber: 'Numéro de TVA',
    cinNumber: 'Numéro CIN',
    companyType: 'Type d\'entreprise',
    legalForm: 'Forme juridique',
    businessName: 'Raison sociale / Nom d\'entreprise',
    experience: 'Expérience',
    skills: 'Compétences',
    qualifications: 'Qualifications',
    description: 'Description',
    about: 'À propos',
    clientCommitments: 'Engagements clients',
    pricing: 'Tarification',
    schedule: 'Disponibilité',
    coverageGuarantees: 'Couvertures et garanties',
    serviceArea: 'Zone d\'intervention',
    paymentMethod: 'Méthode de paiement',
    portfolio: 'Portfolio',
    linkedIn: 'LinkedIn',
    facebook: 'Facebook',
    twitter: 'Twitter / X',
    instagram: 'Instagram',
    website: 'Site web',
    service: 'Service',
    subService: 'Sous-service',
    roles: {
      provider: 'Prestataire',
      user: 'Utilisateur',
      admin: 'Admin',
    },
    userTypes: {
      company: 'Société',
      individual: 'Individuel / Auto-entrepreneur',
    },
    deleteVerificationDocsConfirm: 'Supprimer vos documents de vérification ? Cela remettra votre statut en "en attente".',
    emptyValue: '—',
    portfolioPhotos: '{{count}} photo',
    portfolioPhotos_plural: '{{count}} photos',
    portfolioVideos: '{{count}} vidéo',
    portfolioVideos_plural: '{{count}} vidéos',
    portfolioProjects: '{{count}} fichier',
    portfolioProjects_plural: '{{count}} fichiers',
    registeredOnDate: 'Inscrit le {{date}}',
  },
  pages: {
    notFoundTitle: 'Page introuvable',
    notFoundHeading: 'Oups, page introuvable.',
    notFoundBody: 'Cette page n\'existe pas. Retournez à l\'accueil pour continuer votre navigation sur Allo Alla.',
    goHome: 'Retour à l\'accueil',
    tryAgain: 'Réessayer',
    readFaqs: 'Consulter la FAQ',
    readFaqsDesc: 'Parcourez nos questions fréquentes pour trouver des réponses rapides.',
    readFaqsLink: 'Voir la FAQ',
    helpSupport: 'Aide & support',
    helpSupportDesc: 'Contactez notre équipe pour toute question ou assistance.',
    helpSupportLink: 'Centre d\'aide',
  },
providerSignup: {
    pageTitle: 'Devenir Prestataire de Services',
    heading: 'Devenir Prestataire de Services',
    subtitle: 'Rejoignez notre plateforme et commencez à offrir vos services aux clients. Ajoutez votre photo, les documents pour le badge « Vérifié » et vos horaires pour recevoir des réservations.',
    selectedService: 'Service sélectionné : {{name}}',
    successTitle: 'Inscription réussie !',
    successRedirect: 'Redirection vers la page de connexion...',
    errorTitle: 'Erreur',
    toastSuccess: 'Inscription réussie',
    toastRedirect: 'Redirection vers la connexion...',
    serviceDetails: 'Détails du Service',
    youAre: 'Vous êtes :',
    company: 'Entreprise',
    individual: 'Particulier',
    tradeLabel: 'Métier / Service :',
    mainService: 'Service principal',
    serviceN: 'Service {{n}}',
    remove: 'Retirer',
    service: 'Service',
    subService: 'Sous-service',
    selectService: 'Sélectionnez un service',
    selectSubService: 'Sélectionnez le sous-service',
    add: '+ AJOUTER',
    loadingServices: 'Chargement des services...',
    tradeHint: 'Pour chaque ligne, choisissez un service puis un sous-service (vos choix restent enregistrés dans le formulaire). Cliquez sur + AJOUTER pour afficher une nouvelle ligne avec ses propres listes déroulantes.',
    registrationNumber: "Numéro UTR ou numéro d'immatriculation",
    registrationPlaceholder: "Entrez le numéro d'immatriculation",
    yourPhoto: 'Votre photo',
    profilePhoto: 'Photo de profil',
    photoPreview: 'Aperçu',
    photoHint: 'Format recommandé : JPG ou PNG, max 5 Mo',
    verifiedBadge: 'Badge « Vérifié »',
    verifiedDesc: 'Téléchargez les documents nécessaires pour obtenir le badge « Vérifié » et renforcer la confiance (pièce d\'identité, diplômes, attestations, etc.).',
    documents: 'Documents (PDF ou images)',
    filesSelected: '{{count}} fichier(s) sélectionné(s) : {{names}}',
    cinPhoto: 'Photo CIN (vérification IA)',
    cinHint: 'Ajoutez une photo nette de la CIN pour la vérification automatique.',
    workSchedule: 'Sélectionner les horaires de travail',
    workScheduleDesc: 'Indiquez vos horaires pour commencer à recevoir des demandes de réservation.',
    day: 'Jour',
    open: 'Ouvert',
    from: 'De',
    to: 'À',
    scheduleHint: 'Cochez « Ouvert » et choisissez les heures pour chaque jour.',
    scheduleNotes: 'Remarques (optionnel)',
    scheduleNotesPlaceholder: 'Ex. : Sur rendez-vous le week-end, ou horaires variables...',
    closed: 'Fermé',
    coordinates: 'Coordonnées',
    address: 'Adresse',
    addressPlaceholder: 'Entrez une adresse',
    lastName: 'Nom *',
    lastNamePlaceholder: 'Entrez votre nom',
    lastNameHidden: 'Ne sera pas visible sur le site',
    firstName: 'Prénom *',
    firstNamePlaceholder: 'Entrez votre prénom',
    firstNameVisible: 'Sera visible sur le site',
    email: 'Adresse e-mail *',
    emailPlaceholder: 'Entrez votre email',
    phone: 'Téléphone mobile *',
    phonePlaceholder: 'Entrez votre numéro (8 chiffres)',
    region: 'Région *',
    selectRegion: 'Sélectionnez une région',
    city: 'Ville *',
    selectCity: 'Sélectionnez une ville',
    proInfo: 'Informations professionnelles',
    businessName: 'Métier / Service proposé *',
    businessPlaceholder: 'Ex. : Plombier à domicile, Développeur web, Femme de ménage...',
    experience: "Nombre d'expérience *",
    selectExperience: "Sélectionnez l'expérience",
    exp01: '0-1 an',
    exp25: '2-5 ans',
    exp610: '6-10 ans',
    exp11: '11+ ans',
    description: 'Disponibilité et description du service *',
    descriptionPlaceholder: 'Ex. : Disponible du lundi au vendredi, 9h-18h. Décrivez vos services, votre façon de travailler et ce qui vous distingue...',
    qualifications: 'Compétences',
    qualificationsPlaceholder: 'Ex. : Pose de carrelage, dépannage urgent, rénovation complète, etc.',
    pricing: 'Tarification',
    pricingPlaceholder: 'Ex. : 50€ / heure, 200€ / intervention, devis sur mesure...',
    accountInfo: 'Informations du Compte',
    password: 'Mot de passe *',
    passwordPlaceholder: 'Entrez votre mot de passe',
    confirmPassword: 'Confirmer le mot de passe *',
    confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
    pwdLower: 'Au moins une minuscule',
    pwdUpper: 'Au moins une majuscule',
    pwdDigit: 'Au moins un chiffre',
    pwdLength: 'Au moins 12 caractères',
    backToServices: '← Retour aux Services',
    submit: "S'inscrire comme Prestataire",
    submitting: 'Inscription en cours...',
    days: {
      lun: 'Lundi', mar: 'Mardi', mer: 'Mercredi', jeu: 'Jeudi',
      ven: 'Vendredi', sam: 'Samedi', dim: 'Dimanche',
    },
    errors: {
      tradeRequired: 'Veuillez sélectionner au moins un métier',
      tradeRequiredFull: 'Veuillez sélectionner au moins un métier / service.',
      subServiceRequired: 'Veuillez sélectionner au moins un sous-service pour le service « ligne {{line}} ».',
      registrationRequired: "Le numéro d'immatriculation est requis",
      lastNameRequired: 'Le nom est requis',
      lastNameMin: 'Le nom doit contenir au moins 2 caractères',
      firstNameRequired: 'Le prénom est requis',
      firstNameMin: 'Le prénom doit contenir au moins 2 caractères',
      emailRequired: "L'email est requis",
      emailInvalid: 'Adresse email invalide',
      phoneRequired: 'Le numéro de téléphone est requis',
      phoneDigits: 'Le numéro doit contenir 8 chiffres',
      regionRequired: 'La région est requise',
      cityRequired: 'La ville est requise',
      businessRequired: 'Ce champ est requis',
      experienceRequired: "L'expérience est requise",
      descriptionRequired: 'La description est requise',
      descriptionMin: 'La description doit contenir au moins 20 caractères',
      passwordRequired: 'Le mot de passe est requis',
      passwordCriteria: 'Le mot de passe ne respecte pas les critères',
      confirmRequired: 'Veuillez confirmer votre mot de passe',
      confirmMismatch: 'Les mots de passe ne correspondent pas',
      registerFailed: "L'inscription a échoué. Veuillez réessayer.",
      generic: 'Une erreur est survenue. Veuillez réessayer.',
    },
  },
supportSav: {
    pageTitle: 'Service après-vente',
    badge: 'SAV',
    heading: 'Service après-vente',
    subtitle: 'Réclamations, remboursements, garanties, suivi d\'interventions, support client… Nous vous accompagnons à chaque étape.',
    statTotal: 'Total',
    statPending: 'En attente',
    statInProgress: 'En cours',
    statResolved: 'Résolus',
    tabNew: 'Contacter le SAV',
    tabList: 'Mes demandes',
    tabListCount: 'Mes demandes ({{count}})',
    requestType: 'Type de demande *',
    priority: 'Priorité',
    subject: 'Sujet *',
    subjectPlaceholder: 'Ex: Produit défectueux après livraison',
    reference: 'Référence intervention / commande',
    referencePlaceholder: 'ID ou n° de la commande / intervention (facultatif)',
    provider: 'Prestataire concerné',
    providerPlaceholder: 'Nom du prestataire (facultatif)',
    rating: 'Note (1 à 5)',
    description: 'Description détaillée *',
    descriptionPlaceholder: 'Décrivez votre problème, vos attentes, dates, références...',
    attachments: 'Pièces jointes (factures, photos…)',
    attachmentsHint: 'Jusqu\'à 5 fichiers (images ou PDF).',
    remove: 'Retirer',
    notifyEmail: 'Notifications par email',
    notifySMS: 'Notifications par SMS',
    submit: 'Envoyer la demande',
    submitting: 'Envoi…',
    viewRequests: 'Voir mes demandes',
    historyTitle: 'Historique de mes demandes SAV',
    filterAll: 'Tous les statuts',
    loading: 'Chargement…',
    noTickets: 'Aucune demande pour le moment.',
    colDate: 'Date',
    colType: 'Type',
    colSubject: 'Sujet',
    colStatus: 'Statut',
    colPriority: 'Priorité',
    colMessages: 'Échanges',
    colActions: 'Actions',
    viewReply: 'Voir / Répondre',
    modalTicket: 'Ticket',
    createdAt: 'Date de création',
    status: 'Statut',
    providerLabel: 'Prestataire',
    referenceLabel: 'Référence',
    assignedTo: 'Agent assigné',
    initialDescription: 'Description initiale',
    attachmentsLabel: 'Pièces jointes',
    attachmentN: 'Pièce {{n}}',
    exchanges: 'Échanges',
    noMessages: 'Aucun message pour le moment.',
    reply: 'Répondre',
    replyPlaceholder: 'Votre message…',
    attachFiles: 'Joindre des fichiers (max 3)',
    send: 'Envoyer',
    sending: 'Envoi…',
    resolved: 'Cette demande est résolue.',
    close: 'Fermer',
    loadError: 'Impossible de charger les tickets.',
    fileError: 'Erreur lors du chargement d\'un fichier.',
    validationError: 'Veuillez renseigner un sujet et une description.',
    submitSuccess: 'Votre demande SAV a été enregistrée. Notre équipe vous répondra rapidement.',
    submitError: 'Erreur lors de l\'envoi.',
    messageError: 'Envoi du message échoué.',
    types: {
      reclamation: 'Réclamation',
      remboursement: 'Demande de remboursement',
      'retour-produit': 'Retour produit',
      garantie: 'Garantie',
      'assistance-technique': 'Assistance technique',
      'suivi-intervention': 'Suivi d\'intervention',
      'support-client': 'Support client (chat / email / téléphone)',
      'evaluation-prestataire': 'Évaluation du prestataire',
      'signalement-probleme': 'Signalement de problème',
      historique: 'Historique des commandes / interventions',
    },
    statuses: {
      pending: 'En attente',
      'in-progress': 'En cours',
      resolved: 'Résolu',
    },
    priorities: {
      low: 'Faible',
      medium: 'Moyenne',
      high: 'Haute',
    },
  },
wizardQ: {
    "10": "10",
    "1_journee": "1 journée",
    "1_a_3_mois": "1 à 3 mois",
    "1_a_5_meubles": "1 à 5 meubles",
    "1_2": "1-2",
    "10_a_20": "10 à 20",
    "10_a_20_plants_petit_espace": "10 à 20 plants (petit espace)",
    "100l": "100L",
    "11_a_20_meubles": "11 à 20 meubles",
    "150l": "150L",
    "1er_etage": "1er étage",
    "2_a_4h": "2 à 4h",
    "2_a_5": "2 à 5",
    "2_3": "2-3",
    "20_a_50_plants_jardin_moyen": "20 à 50 plants (jardin moyen)",
    "200l": "200L",
    "2eme_etage": "2ème étage",
    "3_points": "3 points",
    "3_6": "3-6",
    "300l": "300L",
    "30l": "30L",
    "3eme_etage_ou_plus": "3ème étage ou plus",
    "4_ou_plus": "4 ou plus",
    "5_points": "5 points",
    "5_a_10": "5 à 10",
    "50l": "50L",
    "6_a_10_meubles": "6 à 10 meubles",
    "80l": "80L",
    "acces_difficile": "Accès difficile",
    "aide_aux_devoirs": "Aide aux devoirs",
    "alarme_avec_camera": "Alarme avec caméra",
    "allergies_regime_special": "Allergies / Régime spécial",
    "aluminium_metal": "Aluminium / métal",
    "ambiance_lumiere_douce": "Ambiance (lumière douce)",
    "ameliorer_la_luminosite": "Améliorer la luminosité",
    "amenagement_optimisation_de_l_espace": "Aménagement / optimisation de l’espace",
    "amenagement_apres_demenagement": "Aménagement après déménagement",
    "amenagement_complet": "Aménagement complet",
    "amenagement_decoratif_complet": "Aménagement décoratif complet",
    "amenagement_interieur_tiroirs_etageres": "Aménagement intérieur (tiroirs, étagères…)",
    "anti_humidite_moisissure": "Anti-humidité / moisissure",
    "apres_travaux": "Après travaux",
    "arbustes_isoles": "Arbustes isolés",
    "armoire_dressing": "Armoire / Dressing",
    "armoires_murales": "Armoires murales",
    "assez_recent": "Assez récent",
    "audio_multimedia": "Audio / multimédia",
    "aujourdhui": "Aujourd'hui",
    "aujourd_hui": "Aujourd’hui",
    "autonomie_complete": "Autonomie complète",
    "autre_adresse": "Autre adresse",
    "avant_arriere": "Avant + Arrière",
    "avec_ascenseur": "Avec ascenseur",
    "avec_camera": "Avec caméra",
    "avec_des_arbres": "Avec des arbres",
    "avec_des_arbustes": "Avec des arbustes",
    "avec_rangement": "Avec rangement",
    "avec_transport": "Avec transport",
    "avec_une_ile": "Avec une île",
    "avez_vous_besoin_dun_monte_meuble": "Avez-vous besoin d'un monte-meuble ?",
    "avez_vous_besoin_dun_service_de_montage": "Avez-vous besoin d'un service de montage ?",
    "aerer_une_pelouse": "Aérer une pelouse",
    "balancoire": "Balançoire",
    "batterie_12v": "Batterie 12V",
    "batterie_ve_haute_tension": "Batterie VE (Haute tension)",
    "boheme": "Bohème",
    "bois_dur": "Bois dur",
    "bois_massif": "Bois massif",
    "bon_etat": "Bon état",
    "boite_s_aux_lettres": "Boîte(s) aux lettres",
    "boite_s_a_cles": "Boîte(s) à clés",
    "bruit_grincement": "Bruit / Grincement",
    "bureau_local_pro": "Bureau / Local pro",
    "bebe": "Bébé",
    "beton": "Béton",
    "beton_cire": "Béton ciré",
    "cache": "Caché",
    "camera": "Caméra",
    "canalisation_bouchee": "Canalisation bouchée",
    "canape": "Canapé",
    "canape_cuir": "Canapé cuir",
    "canape_tissu": "Canapé tissu",
    "capot_integre": "Capot intégré",
    "capot_retractable": "Capot rétractable",
    "carreaux_de_platre": "Carreaux de plâtre",
    "carrelage_ceramique": "Carrelage/céramique",
    "casse_structure": "Cassé (structure)",
    "cave_grenier": "Cave/Grenier",
    "cave_grenier_garage": "Cave/Grenier/Garage",
    "cela_concerne": "Cela concerne :",
    "chambre_a_coucher": "Chambre à coucher",
    "changement_piece_dusure": "Changement pièce d'usure",
    "changement_piece_mecanique": "Changement pièce mécanique",
    "changement_piece_electrique": "Changement pièce électrique",
    "changement_plusieurs_pieces": "Changement plusieurs pièces",
    "chargement_dechargement": "Chargement + Déchargement",
    "chargement_dechargement_remontage_des_meubles": "Chargement + Déchargement + Remontage des meubles",
    "chargement_dechargement_complet": "Chargement + Déchargement complet",
    "charniere": "Charnière",
    "charniere_abimee": "Charnière abîmée",
    "chauffage_et_eau_chaude": "Chauffage et eau chaude",
    "chauffage_uniquement": "Chauffage uniquement",
    "clairseme": "Clairsemé",
    "climatisation_faible": "Climatisation faible",
    "cloisons_seches": "Cloisons sèches",
    "cloue": "Cloué",
    "cle_cassee": "Clé cassée",
    "cle_perdue": "Clé perdue",
    "colle": "Collé",
    "colonne_de_cabinet": "Colonne de cabinet",
    "combien_darbres_sont_concernes": "Combien d'arbres sont concernés ?",
    "combien_darbustes_cela_concerne_t_il": "Combien d'arbustes cela concerne-t-il ?",
    "combien_delements_sont_impliques": "Combien d'éléments sont impliqués ?",
    "combien_de_fenetres_sont_concernees": "Combien de fenêtres sont concernées ?",
    "combien_de_pieces_sont_concernees": "Combien de pièces sont concernées ?",
    "combien_de_pieces_sont_concernees_facultatif": "Combien de pièces sont concernées ? (facultatif)",
    "combien_de_plants_de_fleurs_planter": "Combien de plants de fleurs planter ?",
    "combien_d_elements_sont_concernes_facultatif": "Combien d’éléments sont concernés ? (facultatif)",
    "compagnie_a_domicile": "Compagnie à domicile",
    "complete": "Complète",
    "conseils_en_decoration": "Conseils en décoration",
    "conseils_en_decoration_interieure": "Conseils en décoration intérieure",
    "conseils_en_eclairage": "Conseils en éclairage",
    "controle_diagnostic": "Contrôle / diagnostic",
    "controle_etriers": "Contrôle étriers",
    "couloir_entree": "Couloir / Entrée",
    "couloir_etroit_escalier_en_colimacon": "Couloir étroit / escalier en colimaçon",
    "creation_de_rangements": "Création de rangements",
    "creation_d_espace_de_rangement": "Création d’espace de rangement",
    "creer_une_ambiance_chaleureuse": "Créer une ambiance chaleureuse",
    "creer_une_ambiance_specifique": "Créer une ambiance spécifique",
    "creez_un_potager": "Créez un potager",
    "cuisine_principale": "Cuisine principale",
    "cuisine_professionnelle": "Cuisine professionnelle",
    "cuisine_secondaire": "Cuisine secondaire",
    "cuisine_equipee": "Cuisine équipée",
    "cablage_et_tirage_de_cables": "Câblage et tirage de câbles",
    "cable": "Câblé",
    "de_plein_air": "De plein air",
    "de_quel_type_de_demande_sagit_il": "De quel type de demande s'agit-il ?",
    "de_quel_type_de_hotte_sagit_il": "De quel type de hotte s'agit-il ?",
    "de_quoi_avez_vous_besoin": "De quoi avez-vous besoin ?",
    "demande_de_details": "Demande de détails",
    "demi_journee": "Demi-journée",
    "diagnostic_electronique": "Diagnostic électronique",
    "donnez_une_estimation_de_la_quantite_surface_facultatif": "Donnez une estimation de la quantité / surface (facultatif)",
    "donnez_une_estimation_des_elements_concernes_facultatif": "Donnez une estimation des éléments concernés (facultatif)",
    "donnez_une_estimation_du_nombre_de_meubles_facultatif": "Donnez une estimation du nombre de meubles (facultatif)",
    "donnez_une_estimation_du_nombre_de_portes_facultatif": "Donnez une estimation du nombre de portes (facultatif)",
    "donnez_une_estimation_du_nombre_de_robinets_facultatif": "Donnez une estimation du nombre de robinets (facultatif)",
    "donnez_une_estimation_du_nombre_d_elements_facultatif": "Donnez une estimation du nombre d’éléments (facultatif)",
    "donnez_une_estimation_du_nombre_d_elements_concernes_facultatif": "Donnez une estimation du nombre d’éléments concernés (facultatif)",
    "douche_bain": "Douche / Bain",
    "duree_du_stockage": "Durée du stockage :",
    "duree_estimee": "Durée estimée :",
    "duree_et_frequence": "Durée et fréquence :",
    "duree_souhaitee": "Durée souhaitée :",
    "debarras_complet": "Débarras complet",
    "debarras_partiel": "Débarras partiel",
    "debouchage": "Débouchage",
    "deboucher_les_canalisations": "Déboucher les canalisations",
    "dechargement": "Déchargement",
    "dechargement_seul": "Déchargement seul",
    "decoratif": "Décoratif",
    "decoration_d_un_espace": "Décoration d’un espace",
    "decouper_un_arbre": "Découper un arbre",
    "decrivez_la_vegetation_de_la_zone_a_defricher": "Décrivez la végétation de la zone à défricher.",
    "decrivez_votre_projet": "Décrivez votre projet",
    "deja_montes": "Déjà montés",
    "demontage": "Démontage",
    "demontage_montage": "Démontage + Montage",
    "demontage_et_installation": "Démontage et installation",
    "demonter": "Démonter",
    "demonter_et_remonter": "Démonter et remonter",
    "depannage": "Dépannage",
    "depannage_reparation_rapide": "Dépannage (réparation rapide)",
    "depannage_sur_place": "Dépannage sur place",
    "depannage_urgence": "Dépannage urgence",
    "depannage_urgent": "Dépannage urgent",
    "depasse": "Dépassé",
    "deplacer_les_tuyaux": "Déplacer les tuyaux",
    "depose_et_pose_de_pavage_exterieur": "Dépose et pose de pavage extérieur",
    "deposer_et_installer_les_joints": "Déposer et installer les joints",
    "deposer_et_installer_un_appareil_electromenager": "Déposer et installer un appareil électroménager",
    "desherbage": "Désherbage",
    "desodorisation": "Désodorisation",
    "detachage": "Détachage",
    "details": "Détails",
    "details_de_votre_demande": "Détails de votre demande",
    "details_supplementaires": "Détails supplémentaires",
    "detartrage_des_canalisations": "Détartrage des canalisations",
    "detecteur": "Détecteur",
    "detecteurs_animaux": "Détecteurs animaux",
    "eau_chaude_uniquement": "Eau chaude uniquement",
    "en_bon_etat": "En bon état",
    "en_coupe": "En coupe",
    "en_haut_et_par_dessus": "En haut et par-dessus",
    "en_profondeur": "En profondeur",
    "enduits_decoratifs_stuc_personnel": "Enduits décoratifs : stuc, personnel",
    "enlevement_encombrants": "Enlèvement encombrants",
    "enlevement_uniquement": "Enlèvement uniquement",
    "entre_1_et_2_metres": "Entre 1 et 2 mètres",
    "entre_10_et_30_metres": "Entre 10 et 30 mètres",
    "entre_2_et_3_metres": "Entre 2 et 3 mètres",
    "entretien_detartrage": "Entretien / détartrage",
    "entretien_regulier": "Entretien régulier",
    "entretien_regulier_nettoyage_protection": "Entretien régulier (nettoyage, protection)",
    "entree_principale": "Entrée principale",
    "est_il_necessaire_de_creer_un_nouveau_circuit_electrique_coupe_passage_de_cables_tirage_de_fil": "Est-il nécessaire de créer un nouveau circuit électrique (coupe, passage de câbles, tirage de fil,...) ?",
    "esthetique": "Esthétique",
    "esthetique_embellir": "Esthétique (embellir)",
    "exemple_1_porte": "Exemple : 1 porte",
    "exemple_1_robinet": "Exemple : 1 robinet",
    "exemple_1_evier": "Exemple : 1 évier",
    "exemple_10": "Exemple : 10",
    "exemple_15": "Exemple : 15",
    "exemple_2": "Exemple : 2",
    "exemple_2_meubles": "Exemple : 2 meubles",
    "exemple_2_equipements": "Exemple : 2 équipements",
    "exemple_20": "Exemple : 20",
    "exemple_20_m": "Exemple : 20 m²",
    "exemple_200": "Exemple : 200",
    "exemple_25_m": "Exemple : 25 m²",
    "exemple_28": "Exemple : 28",
    "exemple_3_rangements": "Exemple : 3 rangements",
    "exemple_3_elements": "Exemple : 3 éléments",
    "exemple_30": "Exemple : 30",
    "exemple_350": "Exemple : 350",
    "exemple_6_m": "Exemple : 6 m²",
    "existe_t_il_un_conduit": "Existe-t-il un conduit ?",
    "extension_systeme": "Extension système",
    "exterieur": "Extérieur",
    "exterieures": "Extérieures",
    "faire_un_tas": "Faire un tas",
    "faudra_t_il_vider_la_ou_les_pieces": "Faudra-t-il vider la ou les pièces ?",
    "faut_il_refaire_les_bordures_de_la_pelouse": "Faut-il refaire les bordures de la pelouse ?",
    "fenetre_a_double_battant": "Fenêtre à double battant",
    "fenetre_a_un_seul_battant": "Fenêtre à un seul battant",
    "fer_forge": "Fer forgé",
    "feuilles_caduques": "Feuilles caduques",
    "feuilles_persistantes": "Feuilles persistantes",
    "fissure": "Fissuré",
    "fixe": "Fixé",
    "fonctionnalite": "Fonctionnalité",
    "frequence": "Fréquence :",
    "gagner_en_fonctionnalite": "Gagner en fonctionnalité",
    "gain_d_espace": "Gain d’espace",
    "garde_meublee": "Garde meublée",
    "garde_a_domicile": "Garde à domicile",
    "goutte_a_goutte": "Goutte-à-goutte",
    "grand_menage": "Grand ménage",
    "grande_taille": "Grande taille",
    "gros_volume": "Gros volume",
    "geometrie": "Géométrie",
    "geothermie": "Géothermie",
    "haie_dense_compacte": "Haie dense/compacte",
    "haie_legere": "Haie légère",
    "haie_mixte": "Haie mixte",
    "haute_securite": "Haute sécurité",
    "hauteur_etages": "Hauteur (étages)",
    "hopital_clinique": "Hôpital / Clinique",
    "il_me_faut_un_broyeur": "Il me faut un broyeur",
    "immediate": "Immédiate",
    "impermeabilisation": "Imperméabilisation",
    "inacheve": "Inachevé",
    "indiquez_une_quantite": "Indiquez une quantité",
    "informations_generales": "Informations générales",
    "installation_equipements_neufs": "Installation (équipements neufs)",
    "installation_amelioration_de_l_eclairage": "Installation / amélioration de l’éclairage",
    "installation_cameras": "Installation caméras",
    "installation_de_decoration_murale": "Installation de décoration murale",
    "installation_de_raccordement_a_la_terre": "Installation de raccordement à la terre",
    "installation_du_drainage": "Installation du drainage",
    "installation_porte_blindee": "Installation porte blindée",
    "installer_un_appareil_menager": "Installer un appareil ménager",
    "installer_un_systeme_de_plomberie": "Installer un système de plomberie",
    "installer_une_cuisine": "Installer une cuisine",
    "installer_une_tige": "Installer une tige",
    "installer_uniquement_les_joints": "Installer uniquement les joints",
    "interphone_audio": "Interphone audio",
    "interphone_audio_video": "Interphone audio/vidéo",
    "interieur_exterieur": "Intérieur + Extérieur",
    "interieur_sale": "Intérieur sale",
    "interieures": "Intérieures",
    "inegal": "Inégal",
    "je_ne_sais_pas": "Je ne sais pas",
    "journee": "Journée",
    "journee_complete": "Journée complète",
    "lave_vaisselle": "Lave-vaisselle",
    "le_revetement_de_sol_existant_doit_il_etre_retire": "Le revêtement de sol existant doit-il être retiré ?",
    "le_revetement_mural_ou_de_sol_existant_doit_il_etre_retire_au_prealable": "Le revêtement mural ou de sol existant doit-il être retiré au préalable ?",
    "le_sol_est_il_pret_a_etre_plante": "Le sol est-il prêt à être planté ?",
    "les_carreaux_doivent_etre_poses": "Les carreaux doivent être posés",
    "les_deux": "Les deux",
    "linge_de_maison": "Linge de maison",
    "local_commercial": "Local commercial",
    "local_pro": "Local pro",
    "local_professionnel": "Local professionnel",
    "leger": "Léger",
    "mdf_agglomere": "MDF / Aggloméré",
    "machine_a_laver": "Machine à laver",
    "maison_complete": "Maison complète",
    "materiaux": "Matériaux",
    "mauvais_etat": "Mauvais état",
    "mauvaise_evacuation": "Mauvaise évacuation",
    "meilleure_organisation": "Meilleure organisation",
    "mettre_dans_sacs": "Mettre dans sacs",
    "mettre_en_avant_certains_elements": "Mettre en avant certains éléments",
    "mettre_en_lumiere": "Mettre en lumière",
    "mettre_le_tableau_electrique_aux_normes": "Mettre le tableau électrique aux normes",
    "meuble_tv": "Meuble TV",
    "meuble_ancien": "Meuble ancien",
    "meuble_exterieur": "Meuble extérieur",
    "meubles_poussieres": "Meubles & poussières",
    "meubles_bas": "Meubles bas",
    "meubles_sous_evier": "Meubles sous évier",
    "meubles_volumineux_dressing_bibliotheque_etc": "Meubles volumineux (dressing, bibliothèque, etc.)",
    "micro_ondes": "Micro-ondes",
    "moderniser_la_decoration": "Moderniser la décoration",
    "modification_ou_creation_de_conduits": "Modification ou création de conduits",
    "moins_d1_mois": "Moins d'1 mois",
    "moins_d1_metre": "Moins d'1 mètre",
    "moins_de_10": "Moins de 10",
    "moins_de_10_metres": "Moins de 10 mètres",
    "moins_de_2h": "Moins de 2h",
    "montage_equilibrage": "Montage + Équilibrage",
    "motoriser_le_portail_existant": "Motoriser le portail existant",
    "motoriser_le_volet_existant": "Motoriser le volet existant",
    "moyen_volume": "Moyen volume",
    "moyenne_5_a_10_cm": "Moyenne (5 à 10 cm)",
    "melange_de_plusieurs_types": "Mélange de plusieurs types",
    "menage_complet": "Ménage complet",
    "metal": "Métal",
    "metal_bois": "Métal + bois",
    "ne_demarre_pas": "Ne démarre pas",
    "nettoyage_apres": "Nettoyage après",
    "nettoyage_interieur": "Nettoyage intérieur",
    "nettoyer_canapes": "Nettoyer Canapés",
    "nettoyer_tapis": "Nettoyer Tapis",
    "neufs_en_kit": "Neufs (en kit)",
    "niveau_de_nettoyage": "Niveau de nettoyage :",
    "niveau_de_securite": "Niveau de sécurité :",
    "niveau_du_sol": "Niveau du sol",
    "nombre_delements": "Nombre d'éléments",
    "nombre_detages_approximatif": "Nombre d'étages approximatif :",
    "nombre_de_vitres": "Nombre de vitres :",
    "non_aucun_travail_preparatoire_nest_necessaire": "Non, aucun travail préparatoire n'est nécessaire.",
    "non_cest_a_lartisan_dapporter_lequipement": "Non, c'est à l'artisan d'apporter l'équipement.",
    "non_il_faut_tirer_un_cable": "Non, il faut tirer un câble.",
    "non_je_men_occuperai_moi_meme": "Non, je m'en occuperai moi-même.",
    "non_les_artisans_doivent_venir_avec_lequipement": "Non, les artisans doivent venir avec l'équipement.",
    "non_a_creer": "Non, à créer",
    "nouvelle_installation": "Nouvelle installation",
    "objet_s_decoratif_s": "Objet(s) décoratif(s)",
    "objets_de_valeur": "Objets de valeur",
    "objets_decoratifs": "Objets décoratifs",
    "organisation_complete": "Organisation complète",
    "oui_aide_chargement": "Oui + aide chargement",
    "oui_deja_installe": "Oui, déjà installé",
    "oui_je_dispose_du_materiel_necessaire": "Oui, je dispose du matériel nécessaire",
    "oui_le_sol_est_pret": "Oui, le sol est prêt",
    "oui_les_bords_de_certains_elements_par_exemple_les_prises_les_portes": "Oui, les bords de certains éléments (par exemple les prises, les portes,...)",
    "oui_a_installer": "Oui, à installer",
    "ou_avez_vous_achete_vos_meubles_de_cuisine_facultatif": "Où avez-vous acheté vos meubles de cuisine ? (facultatif)",
    "ou_se_fera_l_installation_des_meubles": "Où se fera l’installation des meubles ?",
    "ou_se_fera_l_intervention": "Où se fera l’intervention ?",
    "ou_souhaitez_vous_effectuer_votre_travail": "Où souhaitez-vous effectuer votre travail ?",
    "panne_d_equipement": "Panne d’équipement",
    "panneau_de_controle": "Panneau de contrôle",
    "panneaux_en_pvc_ou_stratifies": "Panneaux en PVC ou stratifiés",
    "papier_peint": "Papier peint",
    "particulierement_bas": "Particulièrement bas",
    "particulierement_eleve": "Particulièrement élevé",
    "pas_dacces_vehicule": "Pas d'accès véhicule",
    "pave": "Pavé",
    "perte_de_puissance": "Perte de puissance",
    "perte_d_autonomie": "Perte d’autonomie",
    "petit_volume": "Petit volume",
    "petite_taille": "Petite taille",
    "pierres_naturelles": "Pierres naturelles",
    "piece_principale": "Pièce principale :",
    "plafond_eclairage_general": "Plafond (éclairage général)",
    "plan_d_amenagement": "Plan d’aménagement",
    "planter_un_ou_plusieurs_arbustes": "Planter un ou plusieurs arbustes",
    "plantes_herbacees": "Plantes herbacées",
    "plantez_un_arbre": "Plantez un arbre",
    "plaque_de_platre": "Plaque de plâtre",
    "plaquette_arriere": "Plaquette arrière",
    "plaquette_avant": "Plaquette avant",
    "plateau_coulissant": "Plateau coulissant",
    "pliage_parfait": "Pliage parfait",
    "plus_de_10": "Plus de 10",
    "plus_de_10_chambres": "Plus de 10 chambres",
    "plus_de_10_pieces": "Plus de 10 pièces",
    "plus_de_20": "Plus de 20",
    "plus_de_3_mois": "Plus de 3 mois",
    "plus_de_3_metres": "Plus de 3 mètres",
    "plus_de_30_metres": "Plus de 30 mètres",
    "plus_de_4h": "Plus de 4h",
    "plus_de_6": "Plus de 6",
    "plusieurs_enfants": "Plusieurs enfants",
    "plusieurs_jours": "Plusieurs jours",
    "platre_decoratif": "Plâtre décoratif",
    "platre_ou_stuc": "Plâtre ou stuc",
    "poignee_cassee": "Poignée cassée",
    "portail_autoportant": "Portail autoportant",
    "portail_battant": "Portail battant",
    "portail_coulissant": "Portail coulissant",
    "porte_appartement": "Porte appartement",
    "porte_avec_miroir_integre": "Porte avec miroir intégré",
    "porte_blindee": "Porte blindée",
    "porte_bloquee": "Porte bloquée",
    "porte_claquee": "Porte claquée",
    "porte_d_entree": "Porte d’entrée",
    "porte_interieure": "Porte intérieure",
    "porte_maison": "Porte maison",
    "porte_paliere": "Porte palière",
    "porte_standard": "Porte standard",
    "porte_vitree": "Porte vitrée",
    "porte_fenetre": "Porte-fenêtre",
    "pose_de_pavage_exterieur": "Pose de pavage extérieur",
    "pose_d_etageres_decoratives": "Pose d’étagères décoratives",
    "poele": "Poêle",
    "prise_interrupteur_connecte": "Prise / interrupteur connecté",
    "produits_ecologiques": "Produits écologiques",
    "programmee": "Programmée",
    "precisez_le_type_et_la_quantite_de_tringles_a_rideaux": "Précisez le type et la quantité de tringles à rideaux :",
    "precisez_vos_besoins_la_surface_a_traiter_letat_actuel_du_sol": "Précisez vos besoins, la surface à traiter, l'état actuel du sol...",
    "precisions_sur_votre_demande": "Précisions sur votre demande",
    "preparation_necessaire": "Préparation nécessaire",
    "pret_a_carreler": "Prêt à carreler",
    "pedale_molle": "Pédale molle",
    "que_faut_il_faire_des_feuilles_ramassees": "Que faut-il faire des feuilles ramassées ?",
    "que_faut_il_faire_pour_votre_projet": "Que faut-il faire pour votre projet ?",
    "que_souhaitez_vous": "Que souhaitez-vous ?",
    "que_souhaitez_vous_comme_accompagnement": "Que souhaitez-vous comme accompagnement ?",
    "que_souhaitez_vous_comme_service": "Que souhaitez-vous comme service ?",
    "que_souhaitez_vous_construire_avec_des_plaques_de_platre": "Que souhaitez-vous construire avec des plaques de plâtre ?",
    "que_souhaitez_vous_faire": "Que souhaitez-vous faire ?",
    "que_souhaitez_vous_nettoyer": "Que souhaitez-vous nettoyer ?",
    "que_souhaitez_vous_realiser": "Que souhaitez-vous réaliser ?",
    "quel_est_votre_besoin_principal": "Quel est votre besoin principal ?",
    "quel_type_de_chauffe_eau_facultatif": "Quel type de chauffe-eau (facultatif)",
    "quel_type_de_haie_souhaitez_vous_tailler": "Quel type de haie souhaitez-vous tailler ?",
    "quel_type_de_meubles_aimeriez_vous_creer": "Quel type de meubles aimeriez-vous créer ?",
    "quel_type_de_pavage_souhaitez_vous": "Quel type de pavage souhaitez-vous ?",
    "quel_type_de_revetement_de_sol_est_actuellement_installe": "Quel type de revêtement de sol est actuellement installé ?",
    "quel_type_de_revetement_de_sol_faut_il_enlever": "Quel type de revêtement de sol faut-il enlever ?",
    "quel_type_de_revetement_mural_est_prevu": "Quel type de revêtement mural est prévu ?",
    "quel_type_de_travaux_de_platrerie_souhaitez_vous_realiser": "Quel type de travaux de plâtrerie souhaitez-vous réaliser ?",
    "quel_type_d_espace": "Quel type d’espace ?",
    "quel_type_d_etagere_souhaitez_vous_installer_precisez_la_quantite": "Quel type d’étagère souhaitez-vous installer ? Précisez la quantité.",
    "quel_element_necessite_une_intervention_facultatif": "Quel élément nécessite une intervention (facultatif) ?",
    "quelle_est_la_forme_du_dressing_facultatif": "Quelle est la forme du dressing (facultatif) ?",
    "quelle_est_la_hauteur_approximative_de_lherbe": "Quelle est la hauteur approximative de l'herbe ?",
    "quelle_est_la_hauteur_approximative_du_meuble_a_creer_en_cm_facultatif": "Quelle est la hauteur approximative du meuble à créer, en cm ? (facultatif)",
    "quelle_est_la_hauteur_de_la_haie_facultatif": "Quelle est la hauteur de la haie ? (facultatif)",
    "quelle_est_la_hauteur_du_portail_en_cm_facultatif": "Quelle est la hauteur du portail en cm ? (facultatif)",
    "quelle_est_la_largeur_du_portail_en_cm_facultatif": "Quelle est la largeur du portail en cm ? (facultatif)",
    "quelle_est_la_longueur_approximative_du_meuble_a_realiser_en_cm_facultatif": "Quelle est la longueur approximative du meuble à réaliser, en cm ? (facultatif)",
    "quelle_est_la_longueur_de_la_haie_en_cm_facultatif": "Quelle est la longueur de la haie en cm ? (facultatif)",
    "quelle_est_la_longueur_totale_du_dressing": "Quelle est la longueur totale du dressing ?",
    "quelle_est_la_marque_de_la_cuisine_facultatif": "Quelle est la marque de la cuisine ? (facultatif)",
    "quelle_est_la_marque_du_meuble_concerne_facultatif": "Quelle est la marque du meuble concerné ? (Facultatif)",
    "quelle_est_la_nature_de_votre_demande": "Quelle est la nature de votre demande ?",
    "quelle_est_la_profondeur_du_meuble_a_creer_en_cm_facultatif": "Quelle est la profondeur du meuble à créer, en cm ? (facultatif)",
    "quelle_est_la_superficie_de_la_pelouse_en_m_facultatif": "Quelle est la superficie de la pelouse en m² ? (facultatif)",
    "quelle_est_la_superficie_de_pelouse_a_entretenir_en_m_facultatif": "Quelle est la superficie de pelouse à entretenir, en m² ? (facultatif)",
    "quelle_est_la_superficie_du_potager_en_m_facultatif": "Quelle est la superficie du potager en m² ? (facultatif)",
    "quelle_est_la_superficie_totale_de_la_zone_concernee_en_m2": "Quelle est la superficie totale de la zone concernée en m2 ?",
    "quelle_est_la_superficie_totale_en_metres_carres": "Quelle est la superficie totale en mètres carrés ?",
    "quelle_est_la_surface_approximative_facultatif": "Quelle est la surface approximative ? (facultatif)",
    "quelle_est_la_surface_approximative_a_deneiger_en_m_facultatif": "Quelle est la surface approximative à déneiger (en m²) ? (facultatif)",
    "quelle_est_la_surface_de_la_terrasse_en_m2": "Quelle est la surface de la terrasse en m2 ?",
    "quelle_est_la_surface_a_carreler_en_m": "Quelle est la surface à carreler en m² ?",
    "quelle_est_la_surface_a_couvrir_en_m_facultatif": "Quelle est la surface à couvrir en m² ? (facultatif)",
    "quelle_est_la_surface_a_couvrir_en_metres_carres": "Quelle est la surface à couvrir en mètres carrés ?",
    "quelle_est_la_surface_a_maintenir_en_m_facultatif": "Quelle est la surface à maintenir en m² ? (facultatif)",
    "quelle_est_la_surface_a_peindre_en_m_facultatif": "Quelle est la surface à peindre en m² ? (facultatif)",
    "quelles_sont_les_chambres_concernees": "Quelles sont les chambres concernées ?",
    "quelles_surfaces_doivent_etre_peintes": "Quelles surfaces doivent être peintes ?",
    "quelques_heures": "Quelques heures",
    "quels_sont_les_elements_concernes": "Quels sont les éléments concernés ?",
    "quels_elements_de_salle_de_bains_faut_il_assembler": "Quels éléments de salle de bains faut-il assembler ?",
    "radiateur_a_eau_chaude": "Radiateur à eau chaude",
    "radiateur_electrique": "Radiateur électrique",
    "ramassage_livraison": "Ramassage & Livraison",
    "rangement_dune_piece": "Rangement d'une pièce",
    "recharge_depannage": "Recharge / Dépannage",
    "recommandations_detaillees": "Recommandations détaillées",
    "remettez_en_place_une_tige_existante": "Remettez en place une tige existante",
    "remplacement_batterie": "Remplacement batterie",
    "remplacement_de_vitre": "Remplacement de vitre",
    "remplacement_d_equipements": "Remplacement d’équipements",
    "rendez_vous_medical": "Rendez-vous médical",
    "repassage_delicat": "Repassage délicat",
    "retirer_un_appareil_menager": "Retirer un appareil ménager",
    "revetement": "Revêtement",
    "revetement_exterieur": "Revêtement extérieur",
    "revetement_mural": "Revêtement mural",
    "revetement_texture": "Revêtement texturé",
    "rez_de_chaussee": "Rez-de-chaussée",
    "robinet_bloque": "Robinet bloqué",
    "rotin_osier": "Rotin / osier",
    "rue_etroite": "Rue étroite",
    "reamenagement_optimisation_de_l_espace": "Réaménagement (optimisation de l’espace)",
    "reamenagement_avec_eclairage_decoratif": "Réaménagement avec éclairage décoratif",
    "refrigerateur": "Réfrigérateur",
    "reglage": "Réglage",
    "reglage_ajustement": "Réglage / ajustement",
    "reglage_de_pression": "Réglage de pression",
    "regulier": "Régulier",
    "renovation": "Rénovation",
    "renovation_poncage_peinture": "Rénovation (ponçage, peinture)",
    "renovation_complete": "Rénovation complète",
    "renovation_legere_poncage_vernis": "Rénovation légère (ponçage, vernis)",
    "renover_linstallation_electrique": "Rénover l'installation électrique",
    "reparation": "Réparation",
    "reparation_charniere_poignee": "Réparation (charnière, poignée…)",
    "reparation_fuite_casse": "Réparation (fuite, casse…)",
    "reparation_fuite_dysfonctionnement": "Réparation (fuite, dysfonctionnement)",
    "reparation_alarme": "Réparation alarme",
    "reparation_cameras": "Réparation caméras",
    "reparation_crevaison": "Réparation crevaison",
    "reparation_de_charnieres": "Réparation de charnières",
    "reparation_de_fissures": "Réparation de fissures",
    "reparation_de_tiroirs_portes": "Réparation de tiroirs / portes",
    "reparation_simple_vis_fixation_ajustement": "Réparation simple (vis, fixation, ajustement)",
    "reparation_structurelle_cassure_pied_cadre": "Réparation structurelle (cassure, pied, cadre…)",
    "reparer_la_piece_defectueuse": "Réparer la pièce défectueuse",
    "reparer_le_cadre": "Réparer le cadre",
    "reparer_un_appareil_electromenager": "Réparer un appareil électroménager",
    "reversible": "Réversible",
    "revision": "Révision",
    "revision_freins_complete": "Révision freins complète",
    "saisissez_le_nom_de_la_marque": "Saisissez le nom de la marque",
    "salle_de_bain": "Salle de bain",
    "sans_ascenseur": "Sans ascenseur",
    "sans_fil": "Sans fil",
    "sans_transport": "Sans transport",
    "sera_t_il_necessaire_de_couper": "Sera-t-il nécessaire de couper ?",
    "serrure_bloquee": "Serrure bloquée",
    "serrure_defectueuse": "Serrure défectueuse",
    "serrure_a_cle": "Serrure à clé",
    "sirene": "Sirène",
    "souhaiteriez_vous_une_citerne": "Souhaiteriez-vous une citerne ?",
    "sous_sol": "Sous-sol",
    "spot_encastre": "Spot encastré",
    "stockage_court_terme": "Stockage court terme",
    "stockage_long_terme": "Stockage long terme",
    "stratifie": "Stratifié",
    "supprimer_et_installer": "Supprimer et installer",
    "sur_le_mur": "Sur le mur",
    "sur_le_sol": "Sur le sol",
    "systeme_de_securite": "Système de sécurité",
    "systeme_multipoints": "Système multipoints",
    "systeme_split": "Système split",
    "systeme_a_double_flux": "Système à double flux",
    "systeme_a_flux_unique": "Système à flux unique",
    "systeme_a_humidite_controlee": "Système à humidité contrôlée",
    "seche_serviettes": "Sèche-serviettes",
    "sechoir": "Séchoir",
    "securite_zones_humides": "Sécurité (zones humides)",
    "selectionnez_le_ou_les_appareils_concernes": "Sélectionnez le ou les appareils concernés ?",
    "selectionnez_une_reponse": "Sélectionnez une réponse",
    "taille_standard": "Taille standard",
    "texture": "Texturé",
    "tiroir_bloque": "Tiroir bloqué",
    "toilettes_separees": "Toilettes séparées",
    "tout_evacuer": "Tout évacuer",
    "traitement_du_bois_anti_insectes_anti_humidite": "Traitement du bois (anti-insectes, anti-humidité)",
    "transplanter_larbre_s": "Transplanter l'arbre(s)",
    "transplanter_le_s_arbuste_s": "Transplanter le(s) arbuste(s)",
    "travaux_de_terrassement": "Travaux de terrassement",
    "travaux_decoratifs": "Travaux décoratifs",
    "tri_debarras": "Tri + Débarras",
    "tri_recyclage": "Tri + recyclage",
    "tringle_a_vetements": "Tringle à vêtements",
    "tres_dense": "Très dense",
    "tres_grand": "Très grand",
    "tres_haute_securite": "Très haute sécurité",
    "tres_epais": "Très épais",
    "type_darticle_concerne_precisez_la_quantite": "Type d'article concerné, précisez la quantité :",
    "type_darticle_s_a_monter_precisez_la_quantite": "Type d'article(s) à monter, précisez la quantité :",
    "type_de_batterie": "Type de batterie :",
    "type_de_cameras": "Type de caméras :",
    "type_de_meubles_concernes_selection_multiple_possible": "Type de meubles concernés : (sélection multiple possible)",
    "type_de_porte_de_garage": "Type de porte de garage",
    "type_de_porte_de_garage_type_de_port": "Type de porte de garage :",
    "type_de_prestation_souhaitee": "Type de prestation souhaitée :",
    "type_de_repassage": "Type de repassage :",
    "type_de_salle_de_bain": "Type de salle de bain :",
    "type_de_vehicule": "Type de véhicule :",
    "type_d_alarme": "Type d’alarme :",
    "type_d_intervention_souhaitee": "Type d’intervention souhaitée",
    "type_d_utilitaire": "Type d’utilitaire :",
    "telecommande": "Télécommande",
    "telesurveillance": "Télésurveillance",
    "televiseur_s": "Téléviseur(s)",
    "un_appartement": "Un appartement",
    "un_bureau": "Un bureau",
    "un_ensemble_a_definir": "Un ensemble A définir",
    "une_maison": "Une maison",
    "unite_de_base": "Unité de base",
    "unite_haute": "Unité haute",
    "unite_murale": "Unité murale",
    "unite_portable": "Unité portable",
    "urgence": "Urgence :",
    "usure_normale": "Usure normale",
    "vitres_exterieures": "Vitres extérieures",
    "vitres_interieures": "Vitres intérieures",
    "volume_a_debarrasser": "Volume à débarrasser :",
    "vos_stores_sont": "Vos stores sont",
    "votre_deck_facultatif": "Votre deck (facultatif)",
    "votre_systeme_electrique": "Votre système électrique",
    "voyant_allume": "Voyant allumé",
    "venitien": "Vénitien",
    "verification_generale": "Vérification générale",
    "vetements": "Vêtements",
    "amenagement_des_espaces": "aménagement des espaces",
    "appareil_menager": "appareil ménager",
    "appareils_menagers": "appareils ménagers",
    "application_mobile": "application mobile",
    "assemblee": "assemblée",
    "beton_poli": "beton poli",
    "beton_poli_beton_poli": "béton poli",
    "camera_camera": "caméra",
    "canne_classique": "canne classique",
    "cloisons_seches_cloisons_sec": "cloisons sèches",
    "commande_vocale": "commande vocale",
    "conseil_en_decoration": "conseil en décoration",
    "conseils_en_decoration_conseils_en_": "conseils en décoration",
    "dalle_de_beton": "dalle de béton",
    "dalle_exterieur": "dalle extérieur",
    "dalles_exterieur": "dalles extérieur",
    "densite_moyenne": "densité moyenne",
    "decoration_et_amenagement_des_espaces": "décoration et aménagement des espaces",
    "decoration_murale": "décoration murale",
    "decoration_murale_et_accessoires": "décoration murale et accessoires",
    "demonter_demonter": "démonter",
    "depannage_depannage": "dépannage",
    "entretien_et_depannage": "entretien et dépannage",
    "exemple_10_exemple_10": "exemple : 10",
    "exemple_12": "exemple : 12",
    "exemple_175": "exemple : 175",
    "exemple_2_exemple_2": "exemple : 2",
    "exemple_20_exemple_20": "exemple : 20",
    "exemple_3": "exemple : 3",
    "exemple_300": "exemple : 300",
    "exemples_17": "exemples : 17",
    "hotte_aspirante": "hotte aspirante",
    "hotte_filtrante": "hotte filtrante",
    "hotte_murale": "hotte murale",
    "installation_de_terrasse_en_bois": "installation de terrasse en bois",
    "is_active": "is-active",
    "lit_de_sable": "lit de sable",
    "machine_a_laver_machine_a_la": "machine à laver",
    "marque_de_meubles": "marque de meubles",
    "maconnerie": "maçonnerie",
    "metres_lineaires_pour_votre_cuisine_ex_3": "mètres linéaires pour votre cuisine (ex. : 3)",
    "papier_peint_papier_peint": "papier-peint",
    "pavage_exterieur": "pavage extérieur",
    "plaque_de_cuisson": "plaque de cuisson",
    "plaque_de_platre_plaque_de_pl": "plaque de plâtre",
    "plaque_platre": "plaque plâtre",
    "plaques_de_platre": "plaques de plâtre",
    "plaques_platre": "plaques plâtre",
    "platrage": "plâtrage",
    "platrerie": "plâtrerie",
    "pompe_a_chaleur": "pompe à chaleur",
    "renouvellement_des_plantes": "renouvellement des plantes",
    "reparation_des_meubles": "reparation des meubles",
    "reparation_meuble": "reparation meuble",
    "revetement_de_sol": "revetement de sol",
    "revetement_mural_revetement_m": "revêtement mural",
    "revetement_de_sol_revetement_d": "revêtement de sol",
    "reparation_de_meubles": "réparation de meubles",
    "reparation_des_meubles_reparation_d": "réparation des meubles",
    "reparation_meuble_reparation_m": "réparation meuble",
    "socles_reglables": "socles réglables",
    "tringle_a_rideaux": "tringle a rideaux",
    "tringle_a_rideaux_tringle_a_ri": "tringle à rideaux",
    "tringles_a_rideaux": "tringles a rideaux",
    "tringles_a_rideaux_tringles_a_r": "tringles à rideaux",
    "videosurveillance": "vidéosurveillance",
    "journee_journee": "½ journée",
    "a_convenir": "À convenir",
    "a_discuter": "À discuter",
    "a_discuter_avec_lartisan": "À discuter avec l'artisan",
    "a_discuter_avec_l_artisan": "À discuter avec l’artisan",
    "a_definir": "À définir",
    "a_definir_avec_lartisan": "À définir avec l'artisan",
    "a_definir_avec_le_prestataire": "À définir avec le prestataire",
    "a_definir_avec_l_artisan": "À définir avec l’artisan",
    "a_definir_ensemble": "À définir ensemble",
    "a_demonter_puis_remonter": "À démonter puis remonter",
    "a_determiner_avec_lartisan": "À déterminer avec l'artisan",
    "a_persiennes": "À persiennes",
    "a_preciser": "À préciser",
    "age_et_nombre_d_enfants": "Âge et nombre d’enfants :",
    "eclairage": "Éclairage",
    "eclairage_decoratif": "Éclairage décoratif",
    "eclairage_d_ambiance": "Éclairage d’ambiance",
    "eclairage_fonctionnel_visage_maquillage": "Éclairage fonctionnel (visage, maquillage…)",
    "eclairage_general": "Éclairage général",
    "eclairage_miroir_integre": "Éclairage miroir intégré",
    "elaguer_les_arbres": "Élaguer les arbres",
    "elaguer_un_arbre": "Élaguer un arbre",
    "electrique": "Électrique",
    "electromenager": "Électroménager",
    "eleve": "Élevé",
    "elements_d_installation": "Éléments d’installation",
    "etagere": "Étagère",
    "etagere_avec_rails_reglables": "Étagère avec rails réglables",
    "etagere_verticale": "Étagère verticale",
    "etageres": "Étagères",
    "etageres_bibliotheques": "Étagères / bibliothèques",
    "etageres_decoratives": "Étagères décoratives",
    "etageres_murales": "Étagères murales",
    "etat_moyen": "État moyen",
    "etiquetage": "Étiquetage",
    "evacuateur": "Évacuateur",
    "evacuation_horizontale": "Évacuation horizontale",
    "evacuation_verticale": "Évacuation verticale",
    "evier": "Évier",
    "evier_bassin": "Évier / Bassin",
    "evier_lavabo": "Évier / Lavabo",
    "ilot": "Îlot",
    "ilot_de_cuisine": "Îlot de cuisine",
    "a_motifs": "à motifs",
    "eclairage_eclairage": "éclairage",
    "eclairage_et_home_staging": "éclairage et home staging",
    "eclairage_home_staging": "éclairage home staging",
    "etageres_etageres": "étagères",
    "etagere_etagere": "étagère",
    "etagere_flottante": "étagère flottante",
    "etagere_murale_classique": "étagère murale classique",
    "evier_evier": "évier",
    "acces": "Accès :",
    "ajoutez_au_moins_un_document_pour_continuer": "Ajoutez au moins un document pour continuer.",
    "avec_chauffeur": "Avec chauffeur :",
    "avez_vous_besoin_dun_service_de_demontage": "Avez-vous besoin d'un service de démontage ?",
    "avez_vous_besoin_de_planifier_des_travaux_de_soutien": "Avez-vous besoin de planifier des travaux de soutien ?",
    "avez_vous_besoin_de_prevoir_des_travaux_de_maconnerie": "Avez-vous besoin de prévoir des travaux de maçonnerie ?",
    "avez_vous_des_exigences_particulieres_concernant_la_couleur_des_joints_facultatif": "Avez-vous des exigences particulières concernant la couleur des joints ? (facultatif)",
    "avez_vous_deja_des_poteaux_de_portail_facultatif": "Avez-vous déjà des poteaux de portail ? (facultatif)",
    "besoin_particulier": "Besoin particulier :",
    "certaines_zones_doivent_elles_etre_protegees_avant_detre_peintes": "Certaines zones doivent-elles être protégées avant d'être peintes ?",
    "combien_de_metres_lineaires_pour_votre_cuisine_facultatif": "Combien de mètres linéaires pour votre cuisine ? (facultatif)",
    "combien_de_metres_lineaires_sont_concernes_facultatif": "Combien de mètres linéaires sont concernés ? (Facultatif)",
    "combien_de_plantes_faut_il_planter_facultatif": "Combien de plantes faut-il planter ? (facultatif)",
    "combien_de_prises_interrupteurs": "Combien de prises / interrupteurs ?",
    "combien_de_stores_sont_concernes": "Combien de stores sont concernés ?",
    "combien_de_volets_sont_concernes": "Combien de volets sont concernés ?",
    "comment_souhaitez_vous_controler_le_systeme_facultatif": "Comment souhaitez-vous contrôler le système ? (facultatif)",
    "comment_souhaitez_vous_fixer_vos_plinthes": "Comment souhaitez-vous fixer vos plinthes ? ",
    "comment_utilisez_vous_votre_chaudiere": "Comment utilisez-vous votre chaudière ?",
    "dans_quelles_pieces_avez_vous_besoin_que_ces_travaux_soient_effectues": "Dans quelles pièces avez-vous besoin que ces travaux soient effectués ?",
    "de_quel_type_de_vmc_double_flux_sagit_il": "De quel type de VMC double flux s'agit-il ?",
    "de_quel_type_de_climatiseur_s_agit_il_facultatif": "De quel type de climatiseur s’agit-il ? (facultatif)",
    "de_quel_type_de_materiau_s_apos_agit_il": "De quel type de matériau s&apos;agit-il ?",
    "de_quel_type_de_meubles_sagit_il_veuillez_egalement_preciser_la_quantite_facultatif": "De quel type de meubles s'agit-il ? Veuillez également préciser la quantité (facultatif).",
    "de_quel_type_de_mur_sagit_il": "De quel type de mur s'agit-il ?",
    "de_quel_type_de_plinthe_sagit_il": "De quel type de plinthe s'agit-il ?",
    "de_quels_materiaux_sont_faits_vos_stores": "De quels matériaux sont faits vos stores ?",
    "des_modifications_electriques_passage_de_cables_goulottes_murales_sont_elles_necessaires": "Des modifications électriques (passage de câbles, goulottes murales,...) sont-elles nécessaires ?",
    "des_travaux_de_preparation_du_terrain_sont_ils_necessaires_avant_linstallation": "Des travaux de préparation du terrain sont-ils nécessaires avant l'installation ?",
    "des_travaux_preparatoires_sont_ils_a_effectuer_avant_linstallation_facultatif": "Des travaux préparatoires sont-ils à effectuer avant l'installation ? (facultatif)",
    "destination_du_remorquage": "Destination du remorquage :",
    "disposez_vous_doutils_sur_place_pour_la_maintenance": "Disposez-vous d'outils sur place pour la maintenance ?",
    "disposez_vous_doutils_sur_place_pour_la_taille": "Disposez-vous d'outils sur place pour la taille ?",
    "disposez_vous_doutils_sur_place_pour_tondre_la_pelouse": "Disposez-vous d'outils sur place pour tondre la pelouse ?",
    "distance_entre_le_camion_et_l_apos_entree_approximative": "Distance entre le camion et l&apos;entrée (approximative) :",
    "faut_il_encore_installer_les_raccordements_au_reseau_d_eau_potable": "Faut-il encore installer les raccordements au réseau d’eau potable ?",
    "faut_il_enlever_lancienne_porte_de_garage": "Faut-il enlever l'ancienne porte de garage ?",
    "faut_il_fixer_des_objets_au_mur": "Faut-il fixer des objets au mur ?",
    "faut_il_fixer_des_elements_au_mur": "Faut-il fixer des éléments au mur ?",
    "faut_il_installer_une_unite_exterieure": "Faut-il installer une unité extérieure ?",
    "faut_il_prevoir_un_conduit_d_evacuation_pour_la_hotte_facultatif": "Faut-il prévoir un conduit d’évacuation pour la hotte ? (facultatif)",
    "fonctionnalites": "Fonctionnalités :",
    "hauteur_approximative_des_arbres_a_planter": "Hauteur approximative des arbres à planter",
    "lalimentation_electrique_est_elle_deja_en_place": "L'alimentation électrique est-elle déjà en place ?",
    "lapprovisionnement_en_eau_est_il_deja_en_place": "L'approvisionnement en eau est-il déjà en place ?",
    "linstallation_est_elle_prete": "L'installation est-elle prête ?",
    "lelectricite_est_elle_deja_disponible_a_proximite": "L'électricité est-elle déjà disponible à proximité ?",
    "la_piece_est_elle_completement_vide_de_meubles": "La pièce est-elle complètement vide de meubles ?",
    "la_terrasse_sera_installee_le_optionnel": "La terrasse sera installée le (optionnel)",
    "le_revetement_mural_doit_il_etre_retire": "Le revêtement mural doit-il être retiré ?",
    "le_sol_a_t_il_besoin_de_terre_vegetale_ou_dautres_amendements": "Le sol a-t-il besoin de terre végétale ou d'autres amendements ?",
    "lieu": "Lieu :",
    "lieu_de_prise_en_charge": "Lieu de prise en charge :",
    "lieu_principal": "Lieu principal :",
    "l_alimentation_en_electricite_et_en_eau_est_elle_deja_disponible_facultatif": "L’alimentation en électricité et en eau est-elle déjà disponible ? (facultatif)",
    "materiau_de_la_porte": "Matériau de la porte :",
    "materiau_du_meuble": "Matériau du meuble :",
    "nature_du_probleme_si_reparation": "Nature du problème (si réparation) :",
    "nature_du_probleme": "Nature du problème :",
    "niveau_d_apos_autonomie_ou_besoins": "Niveau d&apos;autonomie ou besoins :",
    "niveau_d_apos_intervention": "Niveau d&apos;intervention :",
    "niveau_d_accompagnement_souhaite": "Niveau d’accompagnement souhaité :",
    "nombre_d_apos_articles": "Nombre d&apos;articles :",
    "nombre_darbres_concernes": "Nombre d'arbres concernés ?",
    "nombre_de_cameras": "Nombre de caméras :",
    "nombre_de_meubles_a_demonter_monter": "Nombre de meubles à démonter / monter :",
    "nombre_de_roues": "Nombre de roues :",
    "objectif_principal": "Objectif principal :",
    "ou_se_situe_le_systeme": "Où se situe le système ?",
    "ou_se_trouvent_les_toilettes": "Où se trouvent les toilettes ?",
    "piece_concernee": "Pièce concernée :",
    "prestation_principale": "Prestation principale :",
    "prestations_complementaires": "Prestations complémentaires :",
    "probleme": "Problème :",
    "probleme_principal": "Problème principal :",
    "probleme_rencontre": "Problème rencontré :",
    "produits_amp_exigences": "Produits &amp; exigences :",
    "precisez_le_type_de_hotte": "Précisez le type de hotte",
    "precisez_les_armoires_a_installer_et_leur_quantite": "Précisez les armoires à installer et leur quantité.",
    "precisions_sur_le_chargement_dechargement": "Précisions sur le chargement / déchargement",
    "preferez_vous_une_installation_qui_soit": "Préférez-vous une installation qui soit :",
    "quel_est_letat_de_la_surface_a_peindre_facultatif": "Quel est l'état de la surface à peindre ? (facultatif)",
    "quel_est_letat_du_sol_mur": "Quel est l'état du sol/mur ?",
    "quel_est_le_format_de_votre_revetement_de_sol_facultatif": "Quel est le format de votre revêtement de sol ? (facultatif)",
    "quel_est_le_type_devacuation_actuel_facultatif": "Quel est le type d'évacuation actuel (facultatif) ?",
    "quel_systeme_souhaitez_vous_facultatif": "Quel système souhaitez-vous ? (facultatif)",
    "quel_type_dalarme_souhaitez_vous_installer": "Quel type d'alarme souhaitez-vous installer ?",
    "quel_type_dinstallation_souhaitez_vous": "Quel type d'installation souhaitez-vous ?",
    "quel_type_de_fenetre_souhaitez_vous": "Quel type de fenêtre souhaitez-vous ?",
    "quel_type_de_feuilles_concerne_votre_demande": "Quel type de feuilles concerne votre demande ?",
    "quel_type_de_finition_souhaitez_vous_facultatif": "Quel type de finition souhaitez-vous ? (facultatif)",
    "quel_type_de_materiaux_pour_vos_volets": "Quel type de matériaux pour vos volets ?",
    "quel_type_de_materiaux_pour_votre_portail": "Quel type de matériaux pour votre portail ?",
    "quel_type_de_materiaux_pour_votre_portail_facultatif": "Quel type de matériaux pour votre portail ? (facultatif)",
    "quel_type_de_materiaux_pour_votre_porte": "Quel type de matériaux pour votre porte ?",
    "quel_type_de_mur": "Quel type de mur ?",
    "quel_type_de_mur_avez_vous": "Quel type de mur avez-vous ?",
    "quel_type_de_portail_souhaitez_vous": "Quel type de portail souhaitez-vous ?",
    "quel_type_de_peripherique_souhaitez_vous_installer": "Quel type de périphérique souhaitez-vous installer ?",
    "quel_type_de_revetement_de_sol_souhaitez_vous_installer": "Quel type de revêtement de sol souhaitez-vous installer ?",
    "quel_type_de_systeme_de_verrouillage_souhaitez_vous_facultatif": "Quel type de système de verrouillage souhaitez-vous ? (facultatif)",
    "quel_type_de_volets_avez_vous": "Quel type de volets avez-vous ?",
    "quel_type_d_energie_utilise_votre_chaudiere": "Quel type d’énergie utilise votre chaudière ?",
    "quel_s_materiau_x_preferez_vous_pour_la_fabrication": "Quel(s) matériau(x) préférez-vous pour la fabrication ?",
    "quelle_est_la_capacite_en_litres_du_chauffe_eau_facultatif": "Quelle est la capacité (en litres) du chauffe-eau ? (facultatif)",
    "quelle_est_la_configuration_de_votre_cuisine_facultatif": "Quelle est la configuration de votre cuisine ? (facultatif)",
    "quelle_est_la_hauteur_approximative_des_arbres_a_planter": "Quelle est la hauteur approximative des arbres à planter ?",
    "quelle_est_la_hauteur_des_arbres": "Quelle est la hauteur des arbres ?",
    "quelle_est_la_hauteur_du_mur_ou_de_la_surface_concernee_facultatif": "Quelle est la hauteur du mur ou de la surface concernée ? (facultatif)",
    "quelle_est_la_longueur_du_mur_ou_de_la_surface_concernee_facultatif": "Quelle est la longueur du mur ou de la surface concernée ? (facultatif)",
    "quelle_est_la_nature_du_mur_facultatif": "Quelle est la nature du mur ? (facultatif)",
    "quelle_est_la_surface_concernee_en_m_facultatif": "Quelle est la surface concernée en m² ? (facultatif)",
    "quelle_est_la_surface_du_plafond_a_enduire_en_m_facultatif": "Quelle est la surface du plafond à enduire, en m² ? (facultatif)",
    "quelle_est_la_surface_murale_a_enduire_en_m_facultatif": "Quelle est la surface murale à enduire, en m² ? (facultatif)",
    "quelles_pieces_sont_concernees": "Quelles pièces sont concernées ?",
    "quels_types_delements_doivent_etre_installes_precisez_la_quantite": "Quels types d'éléments doivent être installés ? Précisez la quantité.",
    "quels_elements_de_salle_de_bains_doivent_etre_demontes": "Quels éléments de salle de bains doivent être démontés ?",
    "sagit_il_des_murs_sur_lesquels_les_plinthes_seront_installees": "S'agit-il des murs sur lesquels les plinthes seront installées ? ",
    "serrure": "Serrure :",
    "services_additionnels": "Services additionnels :",
    "services_souhaites": "Services souhaités :",
    "services_voulus": "Services voulus :",
    "souhaiteriez_vous_que_les_plinthes_soient": "Souhaiteriez-vous que les plinthes soient",
    "souhaitez_vous_installer_un_appareil_electromenager": "Souhaitez-vous installer un appareil électroménager ?",
    "souhaitez_vous_installer_un_thermostat": "Souhaitez-vous installer un thermostat ?",
    "souhaitez_vous_que_lherbe_coupee_soit_enlevee": "Souhaitez-vous que l'herbe coupée soit enlevée ?",
    "souhaitez_vous_une_sous_couche_facultatif": "Souhaitez-vous une sous-couche ? (facultatif)",
    "style_souhaite": "Style souhaité :",
    "superficie_approximative": "Superficie approximative :",
    "sur_quel_type_de_mur_les_meubles_seront_ils_fixes": "Sur quel type de mur les meubles seront-ils fixés ?",
    "symptome": "Symptôme :",
    "selectionnez_le_type_de_dispositif_concerne_precisez_le_nombre_d_apos_unites": "Sélectionnez le type de dispositif concerné, précisez le nombre d&apos;unités ?",
    "selectionnez_le_type_de_porte_a_installer_et_indiquez_la_quantite": "Sélectionnez le type de porte à installer et indiquez la quantité.",
    "selectionnez_les_elements_a_installer_et_specifiez_la_quantite": "Sélectionnez les éléments à installer et spécifiez la quantité ?",
    "type_d_apos_acces": "Type d&apos;accès :",
    "type_de_biens_principaux": "Type de biens principaux :",
    "type_de_biens_principaux_a_transporter_selection_multiple_possible": "Type de biens principaux à transporter : (sélection multiple possible)",
    "type_de_lieu": "Type de lieu :",
    "type_de_meuble": "Type de meuble :",
    "type_de_meubles_rangements": "Type de meubles / rangements :",
    "type_de_meubles": "Type de meubles :",
    "type_de_panne": "Type de panne :",
    "type_de_porte_serrure": "Type de porte / serrure :",
    "type_de_porte": "Type de porte :",
    "type_de_prestation": "Type de prestation :",
    "type_de_rangement": "Type de rangement :",
    "type_de_robinet_de_cuisine": "Type de robinet de cuisine :",
    "type_de_store_precisez_la_quantite": "Type de store, précisez la quantité",
    "type_de_traitement_souhaite": "Type de traitement souhaité :",
    "type_d_intervention": "Type d’intervention :",
    "type_d_eclairage": "Type d’éclairage :",
    "type_d_eclairage_souhaite": "Type d’éclairage souhaité :",
    "type_d_elements_a_installer": "Type d’éléments à installer :",
    "type_principal": "Type principal :",
    "un_entretien_regulier_est_il_necessaire": "Un entretien régulier est-il nécessaire ?",
    "une_installation_electrique_est_elle_necessaire": "Une installation électrique est-elle nécessaire ?",
    "volume_type_de_transport": "Volume / Type de transport :",
    "volume_approximatif": "Volume approximatif :",
    "vos_carreaux_sont": "Vos carreaux sont :",
    "vos_carreaux_sont_ils_la": "Vos carreaux sont-ils là ?",
    "vos_meubles_sont_ils": "Vos meubles sont-ils :",
    "votre_revetement_mural_est_il": "Votre revêtement mural est-il",
    "vehicule": "Véhicule :",
    "y_a_t_il_des_acces_difficiles": "Y a-t-il des accès difficiles ?",
    "y_a_t_il_une_prise_electrique_a_proximite": "Y a-t-il une prise électrique à proximité ?",
    "zone_a_eclairer": "Zone à éclairer :",
    "_journee": "½ journée",
    "equipement_concerne": "Équipement concerné :",
    "equipements_concernes": "Équipements concernés :"
  },
  confirmEmail: {
    pageTitle: 'Confirmation de l\'e-mail',
    loadingTitle: 'Confirmation en cours…',
    loadingBody: 'Nous vérifions votre lien de confirmation.',
    successTitle: 'E-mail confirmé !',
    errorTitle: 'Échec de la confirmation',
    invalidLink: 'Lien de confirmation invalide ou expiré.',
    defaultSuccess: 'Votre adresse e-mail a été confirmée avec succès.',
    defaultError: 'Une erreur est survenue lors de la confirmation de votre e-mail.',
  },
  providerDetails: {
    pageTitle: 'Détails du prestataire',
    heading: 'Informations du prestataire',
    back: 'Retour',
    loading: 'Chargement…',
    notFound: 'Prestataire introuvable.',
    loadError: 'Impossible de charger les informations du prestataire.',
    intro: 'Voici les informations fournies par ce prestataire.',
    noInfo: 'Aucune information disponible pour ce prestataire.',
    service: 'Service',
    subService: 'Sous-service',
    pricing: 'Tarifs',
    zone: 'Zone d\'intervention',
  },
  providerReviews: {
    title: 'Avis clients',
    subtitle: 'Ce que les clients pensent de ce prestataire.',
    reviewsCount: '{{count}} avis',
    noReviews: 'Aucun avis pour le moment.',
    loginPrompt: 'Connectez-vous pour laisser un avis.',
    login: 'Connexion',
    leaveReview: 'Laisser un avis',
    editReview: 'Modifier votre avis',
    ratingLabel: 'Note',
    commentLabel: 'Votre avis',
    commentPlaceholder: 'Partagez votre expérience avec ce prestataire…',
    ratingRequired: 'Veuillez sélectionner une note.',
    commentRequired: 'Veuillez écrire un commentaire.',
    submitting: 'Envoi…',
    publishReview: 'Publier l\'avis',
    updateReview: 'Mettre à jour',
    published: 'Votre avis a été publié.',
    updated: 'Votre avis a été mis à jour.',
    submitError: 'Impossible d\'envoyer votre avis.',
    loadError: 'Impossible de charger les avis.',
    loading: 'Chargement des avis…',
    beFirst: 'Soyez le premier à laisser un avis !',
    ownProfile: 'Vous ne pouvez pas laisser d\'avis sur votre propre profil.',
    client: 'Client',
    ratingAria: 'Note de {{rating}} sur 5',
    rateAria: 'Donner une note de {{n}} sur 5',
    pickRating: 'Choisir une note',
  },
  serviceProviders: {
    pageTitle: 'Prestataires',
    forService: 'Prestataires pour : {{name}}',
    browseDesc: 'Parcourez les prestataires disponibles pour ce service.',
    loadingServiceInfo: 'Chargement des informations du service…',
    loading: 'Chargement des prestataires…',
    loadFailed: 'Impossible de charger les prestataires.',
    noServiceSelected: 'Aucun service sélectionné.',
    noServiceTitle: 'Service introuvable',
    noServiceBody: 'Nous n\'avons pas trouvé ce service. Parcourez la liste des services disponibles.',
    found: '{{count}} prestataire trouvé',
    found_plural: '{{count}} prestataires trouvés',
    backToServicesLink: '← Retour aux services',
    backToServices: 'Retour aux services',
    mapTitle: 'Carte des prestataires',
    mapHint: 'Localisez les prestataires près de chez vous.',
    contactSectionTitle: 'Contacter un prestataire',
    contactSectionDesc: 'Choisissez un prestataire et contactez-le directement.',
    itsYou: 'C\'est vous',
    yearsExp: '{{years}} ans d\'expérience',
    availability: 'Disponibilité',
    zone: 'Zone',
    pricing: 'Tarifs',
    paymentMethod: 'Mode de paiement',
    portfolio: 'Portfolio',
    portfolioMore: '+{{count}} photos',
    contactProvider: 'Contacter le prestataire',
    leaveReview: 'Laisser un avis',
    loadErrorTitle: 'Une erreur est survenue',
    noneTitle: 'Aucun prestataire disponible',
    noneBody: 'Aucun prestataire n\'est encore inscrit pour ce service dans votre zone.',
    reviewsCount: '{{count}} avis',
  },
  servicesPage: {
    pageTitle: 'Nos services',
    badge: 'Services',
    title: 'Tous nos services',
    subtitle: 'Trouvez le service qu\'il vous faut parmi nos catégories.',
    becomeProvider: 'Devenir prestataire',
    publishRequest: 'Publier une demande',
  },
serviceCatalog: {
    subServicesTitle: 'Sous-services {{name}}',
    noSubServices: 'Aucun sous-service disponible pour le moment.',
    categories: {
      furniture: {
        name: 'Mobilier & Décoration',
        subtitle: 'Services de montage et de décoration pour organiser vos espaces et finaliser votre intérieur avec soin.',
      },
      kitchen: {
        name: 'Cuisine',
        subtitle: 'Prestations dédiées à la cuisine pour poser, ajuster et installer vos éléments avec précision et sécurité.',
      },
      bathroom: {
        name: 'Salle de bain',
        subtitle: 'Aménagement et rénovation de salle de bain pour un espace fonctionnel, moderne et adapté à vos usages.',
      },
      floorWall: {
        name: 'Sol & Mur',
        subtitle: 'Travaux de revêtement pour sols et murs afin d\'améliorer l\'esthétique, la protection et la durabilité de vos pièces.',
      },
      plumbing: {
        name: 'Plomberie & Chauffage',
        subtitle: 'Services de plomberie et de chauffage pour réparer, installer et optimiser vos équipements au quotidien.',
      },
      electricity: {
        name: 'Électricité',
        subtitle: 'Interventions électriques pour moderniser vos installations, améliorer votre confort et assurer la conformité de votre logement.',
      },
      carpentry: {
        name: 'Menuiserie',
        subtitle: 'Travaux de menuiserie pour installer, réparer ou fabriquer des éléments en bois avec des finitions durables et soignées.',
      },
      gardening: {
        name: 'Jardinage',
        subtitle: 'Entretien et aménagement de vos espaces verts pour garder un jardin propre, harmonieux et agréable toute l\'année.',
      },
      cleaning: {
        name: 'Ménage & Nettoyage',
        subtitle: 'Prestations de ménage et de nettoyage adaptées à votre besoin : entretien quotidien, remise en état et nettoyage en profondeur.',
      },
      moving: {
        name: 'Déménagement',
        subtitle: 'Services complets pour un déménagement plus simple : préparation, transport, manutention et installation de vos meubles en toute sérénité.',
      },
      security: {
        name: 'Sécurité & Serrurerie',
        subtitle: 'Solutions de protection et de serrurerie pour sécuriser votre logement, prévenir les intrusions et dépanner rapidement en cas d\'urgence.',
      },
      mechanic: {
        name: 'Mécanicien',
        subtitle: 'Interventions mécaniques courantes pour entretenir votre véhicule, améliorer ses performances et garantir votre sécurité sur la route.',
      },
    },
    sub: {
      assemblee: 'Assemblée',
      montage_meubles: 'Montage des meubles',
      fixation_murale: 'Fixation murale',
      tringle_rideaux: 'Tringle à rideaux',
      traitement_meubles: 'Traitement des meubles',
      reparation_meubles: 'Réparation de meubles',
      decoration_murale: 'Décoration murale et accessoires',
      decoration_espaces: 'Décoration et aménagement des espaces',
      entretien_meubles: 'Entretien et traitement des meubles',
      eclairage_staging: 'Éclairage et home staging',
      conseil_decoration: 'Conseil en décoration',
      meubles_sur_mesure: 'Meubles sur mesure',
      meubles_cuisine: 'Meubles de cuisine',
      appareils_menagers: 'Appareils menagers',
      hotte_cuisine: 'Hotte de cuisine',
      plomberie: 'Plomberie',
      robinetterie: 'Robinetterie',
      espace_rangement: 'Espace rangement',
      salle_de_bain: 'Salle de bain',
      chauffe_eau: 'Chauffe eau',
      mastic: 'Mastic',
      toilettes: 'Toilettes',
      meubles_rangement: 'Meubles et rangement',
      cabine_douche: 'Cabine de douche',
      eclairage: 'Eclairage',
      carrelage: 'Carrelage',
      peinture: 'Peinture',
      papier_peint: 'Papier peint',
      parquet: 'Parquet',
      platrage: 'Plâtrage',
      plaques_platre: 'Plaques de plâtre',
      dalles_exterieures: 'Dalles extérieures',
      plinthes: 'Plinthes',
      terrasse: 'Terrasse',
      tapis: 'Tapis',
      beton_poli: 'Béton poli',
      revetement_sol: 'Revêtement de sol',
      maconnerie: 'Maçonnerie',
      climatisation: 'Climatisation',
      chauffage: 'Chauffage',
      chaudiere: 'Chaudière',
      tuyaux: 'Tuyaux',
      entretien_depannage: 'Entretien et depannage',
      prises_interrupteurs: 'Prises / Interrupteurs',
      alarme_camera: 'Alarme / Caméra',
      interphone: 'Interphone',
      domotique: 'Domotique',
      portail_motorise: 'Portail motorisé',
      bornes_tableaux: 'Bornes electriques/Tableaux électriques',
      volet_motorise: 'Volet motorisé',
      garage_motorise: 'Garage motorisé',
      store_motorise: 'Store motorisé',
      vmc: 'VMC',
      reparation_menuiserie: 'Réparation de menuiserie',
      stores: 'Stores',
      portail: 'Portail',
      porte: 'Porte',
      fenetres: 'Fenetres/Portes-fenetres',
      vestiaire: 'Vestiaire',
      cuisine: 'Cuisine',
      obturateur: 'Obturateur',
      porte_garage: 'Porte de garage',
      espaces_verts: 'Espaces verts',
      tondre: 'Tondre',
      haies: 'Haies',
      abattage_arbres: 'Abbatage d arbres',
      pelouse: 'Pelouse',
      planter_arbre: 'Plantez un arbre',
      clairiere: 'Clairiere',
      arbustes: 'Arbustes',
      feuilles: 'Feuilles',
      fleurs: 'Fleurs',
      potager: 'Potager',
      menage_surface: 'Ménage surface et meubles',
      repassage: 'Répassage',
      nettoyage_vitres: 'Nettoyage vitres',
      nettoyage_tapis: 'Nettoyage de tapis et canapés',
      debarass: 'Débarras',
      organisation_rangement: 'Organisation et rangement',
      chargement_dechargement: 'Chargement et déchargement',
      montage_demontage: 'Montage / Démontage meubles',
      accompagnement_personnes_agees: 'Accompagnement des personnes âgées',
      stockage_meubles: 'Stockage et garde des meubles',
      garde_enfants: 'Garde et accompagnement d\'enfants',
      location_utilitaire: 'Location utilitaire avec chauffeur',
      ouverture_porte: 'Ouverture de porte',
      portes_securisees: 'Portes sécurisées',
      serrurerie: 'Serrurerie',
      alarmes: 'Alarmes',
      cameras: 'Caméras',
      entretien_reparation: 'Entretien et réparation',
      changement_roues: 'Changement de roues',
      batterie_electrique: 'Batterie electrique',
      plaquettes_frein: 'Changement plaquette de frein',
      depannage_remorquage: 'Dépannage et remorquage',
      changement_pieces: 'Changement de pièces auto',
      diagnostique_nettoyage: 'Diagnostique et nettoyage',
    },
    main: {
      meuble_decoration: 'Meuble & Décoration',
      mobilier_decoration: 'Mobilier & Décoration',
      cuisine: 'Cuisine',
      salle_de_bain: 'Salle de bain',
      sol_mur: 'Sol & Mur',
      electricite: 'Électricité',
      plomberie_chauffage: 'Plomberie & Chauffage',
      menuiserie: 'Menuiserie',
      jardinage: 'Jardinage',
      mecancien: 'Mécancien',
      demenagement: 'Déménagement',
      menage_nettoyage: 'Ménage & Nettoyage',
      securite_serrurerie: 'Sécurité & Serrurerie',
    },
    details: {
      ourServices: 'Nos services de {{service}}',
      welcome1: 'Bienvenue sur notre page dédiée à {{service}}. Que vous souhaitiez une installation, une réparation ou une rénovation complète, nous proposons des interventions adaptées à vos besoins.',
      welcome2: 'Nous mettons à votre disposition une équipe d\'experts pour garantir un résultat fiable, durable et conforme à vos attentes.',
      transparentPricing: 'Tarification transparente',
      transparentPricingDesc: 'Comparez facilement les offres et choisissez le prestataire qui vous convient.',
      verifiedProviders: 'Prestataires vérifiés',
      verifiedProvidersDesc: 'Sélection de professionnels qualifiés avec des avis clients authentiques.',
      satisfiedOrRedone: 'Satisfait ou refait',
      satisfiedOrRedoneDesc: 'Une qualité suivie pour vous offrir plus de confiance sur chaque mission.',
      insuranceIncluded: 'Assurance incluse',
      insuranceIncludedDesc: 'Des prestations réalisées avec un niveau de sécurité et de responsabilité élevé.',
      expertsTitle: 'Des professionnels en charge de vos besoins en {{service}}',
      expert1: 'Artisan polyvalent: interventions rapides et soignées pour vos besoins en {{service}}.',
      expert2: 'Installation et pose: réalisation selon les normes avec finitions propres.',
      expert3: 'Réparation et maintenance: diagnostic, remise en état et suivi des travaux.',
      expert4: 'Rénovation complète: accompagnement du début à la livraison finale.',
      expert5: 'Conseils techniques: choix des matériaux adaptés à votre budget.',
      expert6: 'Qualité contrôlée: prestations évaluées et satisfaction client vérifiée.',
      processTitle: 'Réalisez tous vos projets sur mesure',
      step1Title: 'Postez votre demande',
      step1Text: 'Sélectionnez un service et décrivez rapidement vos besoins.',
      step2Title: 'Recevoir des devis',
      step2Text: 'Des artisans compétents et locaux établissent des devis.',
      step3Title: 'Payez votre demande',
      step3Text: 'Choisissez votre mode de paiement pour réserver un artisan.',
      step4Title: 'Évaluez votre artisan',
      step4Text: 'Planifiez un rendez-vous et évaluez le travail accompli.',
      reviewExcellent: 'Excellent',
      reviewExcellentText: 'Basé sur 14,496 avis vérifiés.',
      reviewVerified1: 'Vérifié',
      reviewVerified1Text: 'Grande qualité de service et intervention rapide.',
      reviewVerified2: 'Vérifié',
      reviewVerified2Text: 'Prestation claire, artisan fiable, résultat propre.',
      reviewVerified3: 'Vérifié',
      reviewVerified3Text: 'Très bonne expérience, je recommande sans hésitation.',
      reasonsTitle: 'Trois raisons de choisir un prestataire Allo Alla',
      reason1Title: 'Assurance vérifiée',
      reason1Text: 'Nos prestataires qualifiés doivent être couverts par une assurance décennale ou une assurance responsabilité civile professionnelle. Notre équipe vérifie la validité de ce document afin de garantir la conformité de votre contrat.',
      reason2Title: 'Avis clients',
      reason2Text: 'Après chaque projet, les clients laissent des avis sur le profil des artisans. Vous pouvez consulter les avis précédents pour vous rassurer sur le prestataire et orienter votre choix.',
      reason3Title: 'Obtenez le meilleur prix',
      reason3Text: 'Lorsque vous effectuez une demande sur notre site, vous recevez plusieurs devis d\'artisans en fonction de votre budget. Cela vous permet de comparer les prix et d\'obtenir le meilleur tarif.',
      otherServicesTitle: 'Autres services',
      otherFurniture: 'Mobilier et décoration',
      otherKitchen: 'Cuisine',
      otherElectricity: 'Électricité',
      otherBathroom: 'Salle de bain',
    },
  }
};

export default fr;
export const catalogFr = fr.serviceCatalog;
